webpackJsonp([1],{

/***/ 216:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAE+0lEQVR4Xu3d4ZUNQRAF4LsRkAEiIIOVARksGRABIiADRIAIrAiWCJABGTiX9w7n2d033V3VXd115xzHn5k31XW/6Te7P2pPoCN1B05Sr16LhwAkRyAAApC8A8mXrx1AAJJ3IPnytQMIQPIOJF++dgABSN6B5MvXDiAAyTuQfPnaAQQgeQeSL187gAAk70Dy5ffYAW4DuLXr808Anwf2PFItA9vw99aeANjs1wDuH6z0G4CnAN537MA9AC+vqOUxgPOOtYS6lRcANvwjgJvXrPbVDoJ3Qwjw3ZFaiOCNdyERP98LwAUAIjh2sOlsvtdBgF+PhL+/d0oEHgD4xPHp33p4Ini0+xraWks6BB4AngN4trXju/O8EPA940FhLakQRAHAjDwQ8OXutBAAT0+DIBIADwREdVYBIA0CDwB8+eNLYO1huROUvgMc1rz8TuABgE2s3Xr3AVgi4C+e7tZqXP3rwAsAf/wigpbGWyHgjsRabgjB/x3wAsA7CUGDuF6XegIQgl4pNtzHG4AQNITT49IeAISgR5KV9+gFQAgqA/K+rCcAIfBOs+LzewMQgoqQPC8ZAUAIPBMt/OxRAISgMCiv00cCEAKvVAs+dzQAISgIy+PUCACEwCPZjZ8ZBYAQbAzM+rRIAITAOt0NnxcNgBBsCM3ylIgAhMAy4SOfFRWAEHRCEBmAEHRAEB2AEDgjmAGAEDgimAWAEDghmAmAEDggmA2AEBgjmBGAEBgimBWAEBghmBmAEBggmB2AEDQiWAGAEDQgWAWAEFQiWAmAEFQgWA2AEBQiWBGAEBQgWBWAFYIXADj1rPUIO6RiZQBWCO4A4Hjb1qMVwQ8ArIX/mx2rA7BAYLULsBYi4OzC/fDs0iDNh1ZlANCK4NMlQ6ZLg/v3/JbROZYYf9eUCQDH126ZX3wY7gcAD1sSP7h2yyDtq24nABVB8ImrDZ+3s2x6S/isRV8BhQBaw+ftLF8Cj43Qv255/GMb/BsMegnciMAifKunv/XJd3n6V34HsAj/LQCOmm09woa/KgCFX0B2tZ8CFH5B+KvtAAq/MPyVACj8ivBXAaDwK8NfAYDCbwh/dgAKvzH8mQEofIPwZwWg8I3CnxGAwjcMfzYACt84/JkAKHyH8GcBoPCdwp8BgMJ3DD86AIXvHH5kAAq/Q/hRASj8TuFHBKDwO4YfDYDC7xx+JAAKf0D4UQAo/EHhRwCg8AeGPxqAwh8c/kgACj9A+KMAKPwg4Y8AoPADhd8bgMIPFn5PAAo/YPi9ACj8oOH3AKDwA4fvDUDhBw/fE4DCnyB8TwAchXK/oQdWwxlYwkXlcKh9+eZzeRr6Yn6px3wATsRg02sPy/A54eN1bSEeQ5kaanG51AMAR6s+q6zWMnyW8AbAWWUtSz/5+55EAmAdPtd4DuC0AkCK8L3eAWp2AI/wa3eANOF7ASh9B/BseOk7gGctFRuR/yUeXwElW2+PhnPS95bhzD1q8U+08A5eAPh7gM9HGt+r4VvGtPeqpTAe/9O9ALByInh1yVv4dwBPdmPT/Vf45w5EwFoOXwi/7IZBEmvKwxPAvqGEsJ/SzTm3I5vNWbv8x2N0LSHA9QAQYqEq4vIOCEByGQIgAMk7kHz52gEEIHkHki9fO4AAJO9A8uVrBxCA5B1IvnztAAKQvAPJl68dQACSdyD58rUDCEDyDiRfvnaA5AB+AdqqfpADuOawAAAAAElFTkSuQmCC"

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_polyfill__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_ls___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.API = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].API_URL;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$messagesuccess = function (msg) {
  __WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.Message({
    showClose: true,
    message: msg,
    type: 'success'
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$messagewarning = function (msg) {
  __WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.Message({
    showClose: true,
    message: msg,
    type: 'warning'
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$messageerror = function (msg) {
  __WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.Message({
    showClose: true,
    message: msg,
    type: 'error'
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = function (msg) {
  __WEBPACK_IMPORTED_MODULE_1_element_ui___default.a.Message({
    showClose: true,
    message: msg
  });
};

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].afterEach(function (to, from, next) {
  window.scrollTo(0, 0);
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  API_URL:  true ? '' : 'http://192.168.205.150:2066'
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Entry__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Entry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Entry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Interview__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Interview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Interview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Award__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Award___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Award__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Top__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Recommend__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Recommend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Recommend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Top100__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Top100___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Top100__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Exhibition__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Exhibition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Exhibition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Qa__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Qa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Qa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Login__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Regist__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Regist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Regist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Post__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Work__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_WorkDetail__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_WorkDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_WorkDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_WorkDetailUpdate__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_WorkDetailUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_WorkDetailUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_User__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_ChangeInfo__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_ChangeInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_ChangeInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_UserChangePwd__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_UserChangePwd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_UserChangePwd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_ForgetPwd__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_ForgetPwd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_ForgetPwd__);























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/entry',
    name: 'entry',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Entry___default.a
  }, {
    path: '/interview',
    name: 'interview',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Interview___default.a
  }, {
    path: '/award',
    name: 'award',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Award___default.a
  }, {
    path: '/toplist',
    name: 'toplist',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Top100___default.a
  }, {
    path: '/recommend',
    name: 'recommend',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Recommend___default.a
  }, {
    path: '/top',
    name: 'top',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Top___default.a
  }, {
    path: '/exhibition',
    name: 'exhibition',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Exhibition___default.a
  }, {
    path: '/exhibition/:id',
    name: 'exhibition',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Exhibition___default.a
  }, {
    path: '/qa',
    name: 'qa',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Qa___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Login___default.a
  }, {
    path: '/regist',
    name: 'Regist',
    component: __WEBPACK_IMPORTED_MODULE_12__views_Regist___default.a
  }, {
    path: '/post',
    name: 'Post',
    component: __WEBPACK_IMPORTED_MODULE_13__views_Post___default.a
  }, {
    path: '/work',
    name: 'Work',
    component: __WEBPACK_IMPORTED_MODULE_14__views_Work___default.a
  }, {
    path: '/workdetail/:id',
    name: 'WorkDetail',
    component: __WEBPACK_IMPORTED_MODULE_15__views_WorkDetail___default.a
  }, {
    path: '/workdetailupdate/:id',
    name: 'WorkDetailUpdate',
    component: __WEBPACK_IMPORTED_MODULE_16__views_WorkDetailUpdate___default.a
  }, {
    path: '/user',
    name: 'User',
    component: __WEBPACK_IMPORTED_MODULE_17__views_User___default.a
  }, {
    path: '/changeInfo',
    name: 'ChangeInfo',
    component: __WEBPACK_IMPORTED_MODULE_18__views_ChangeInfo___default.a
  }, {
    path: '/userchangepwd',
    name: 'UserChangePwd',
    component: __WEBPACK_IMPORTED_MODULE_19__views_UserChangePwd___default.a
  }, {
    path: '/forgetpwd',
    name: 'ForgetPwd',
    component: __WEBPACK_IMPORTED_MODULE_20__views_ForgetPwd___default.a
  }]
}));

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      token: "",
      isRouterAlive: true,
      menus: [{
        name: "首页",
        path: "/home"
      }, {
        name: "100强名单",
        path: "/top"
      }, {
        name: "往届作品",
        path: "/entry"
      }, {
        name: "常见问题",
        path: "/qa"
      }]

    };
  },

  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#animation_zh>li").mouseenter(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("div").stop().animate({ "width": "250px" });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css("color", "white");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css("opacity", 1);
    }).mouseleave(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).children("div").stop().animate({ "width": "0" });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css("color", "");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).css("opacity", 0.8);
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".aboutme").mouseenter(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".myinfo").slideDown(100);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".zh_myinfo").slideDown(100);
    }).mouseleave(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".myinfo").slideUp(100);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".zh_myinfo").slideUp(100);
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scroll(function () {
      var scroH = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop();
      var viewH = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
      var contentH = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height();
      if (scroH > 100) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".huojian").stop().show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".huojian").stop().hide();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".huojian").click(function () {
      document.getElementsByTagName('html')[0].scrollTop = 0;
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".ball_wx").mouseenter(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".erweima").show();
    }).mouseleave(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".erweima").hide();
    });

    function checkIE() {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
    }
    if (checkIE()) {
      window.addEventListener('hashchange', function () {
        var currentPath = window.location.hash.slice(1);
        if (_this.$route.path !== currentPath) {
          _this.$router.push(currentPath);
        }
      }, false);
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    token: function token(val) {
      var _t = this;
      _t.$ls.set("token", val);
    }
  },
  methods: {
    goAnchor: function goAnchor(id) {
      document.getElementById(id).scrollIntoView();
    },

    load: function load() {
      var _t = this;
      _t.token = _t.$ls.get("token", "");
    },
    changeToken: function changeToken(val) {
      var _t = this;
      _t.token = val;
    },
    logout: function logout() {
      var _t = this;
      _t.token = "";
      _t.$ls.remove("token");
      _t.$router.push("/");
      _t.reload();
    },
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    provide: function provide() {
      return {
        reload: this.reload
      };
    },
    toMenu: function toMenu(path, index) {
      this.$router.push(path);
    }
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_video_player__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_0_vue_video_player__["videoPlayer"]
  },
  data: function data() {
    return {
      playerOptionsLi: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zhulei.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/zhulei.jpg'
      },
      playerOptionsZhu: {
        height: '240',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/yangzhijiang.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/yangzhijiang.jpg'
      },
      playerOptionsXia: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/jieyuqi.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/jieyuqi.jpg'
      },
      playerOptionsHu: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/xinshanchao.mp4'
        }],
        poster: 'http://ss.archirookies.com/assets/xinshanchao.jpg'
      },
      playerOptions1: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin1.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions2: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin2.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions3: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin3.mp4'
        }],
        poster: 'poster.jpg'
      },
      playerOptions4: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4',
          src: 'http://ss.archirookies.com/assets/zuopin4.mp4'
        }],
        poster: 'poster.jpg'
      }
    };
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {}
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _user;

    return {
      token: '',
      url: this.API,
      baseUrl: this.API + 'assets/upload/',
      dialogUrl: '',
      dialogVisible: false,
      avatarIsMax: false,
      avatarList: [],
      user: (_user = {
        name: '',
        phone: '',
        addr: '',
        teacher: '',
        major: '',
        userid: '',
        avatar_url: ''
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user, 'addr', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user, 'email', ''), _user)
    };
  },

  computed: {
    headers: function headers() {
      var _t = this;
      return {
        Token: _t.token
      };
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this._getData();
  },

  filters: {},
  methods: {
    prepage: function prepage() {
      this.$router.go(-1);
    },
    _getData: function _getData() {
      var _t = this;
      _t.token = _t.$ls.get('token');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/user/all', { token: _t.token }).then(function (resp) {
        if (resp.data.code === '401') {
          _t.$router.push('/login/');
          return;
        }
        if (resp.data.code === '0') {
          _t.user = resp.data.user;
          if (_t.user.avatar_url != "" && _t.user.avatar_url != undefined) {
            _t.avatarIsMax = true;
            _t.avatarList.push({ name: 'avatar', url: _t.baseUrl + _t.user.avatar_url, file: _t.user.avatar_url });
          }
        } else {
          _t.$messagewarning(resp.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    saveInfo: function saveInfo() {
      var _user2;

      var _t = this;
      _t.token = _t.$ls.get("token");
      var ld = __WEBPACK_IMPORTED_MODULE_2_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '保存中，请稍后' });

      if (_t.user.name == '' || _t.user.phone == '' || _t.user.addr == '' || _t.user.email == '') {
        _t.$messagewarning("请填写完整信息");
        ld.close();
        return;
      }
      if (_t.user.teacher == '') {
        _t.$messagewarning("请填写指导老师");
        ld.close();
        return;
      }
      if (_t.user.major == '') {
        _t.$messagewarning("请填写专业");
        ld.close();
        return;
      }
      if (_t.user.userid == '') {
        _t.$messagewarning("请填写编号");
        ld.close();
        return;
      }
      if (_t.user.avatar_url == '') {
        _t.$messagewarning("请上传个人生活照");
        ld.close();
        return;
      }
      var user = (_user2 = {
        token: _t.token,
        name: _t.user.name,
        phone: _t.user.phone,
        addr: _t.user.addr,
        teacher: _t.user.teacher,
        major: _t.user.major,
        userid: _t.user.userid,
        avatar_url: _t.user.avatar_url
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user2, 'addr', _t.user.addr), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_user2, 'email', _t.user.email), _user2);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/api/user/updateInfo", user).then(function (resp) {
        if (resp.data.code === '0') {
          _t.$messagesuccess(resp.data.msg);
          _t.$router.push('/user');
        } else {
          _t.$messagewarning(resp.data.msg);
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      var _t = this;
      _t.user.avatarUrl = '';
      _t.avatarList = [];
      _t.avatarIsMax = false;
      return;
    },
    handlePreview: function handlePreview(file) {
      this.dialogUrl = file.url;
      this.dialogVisible = true;
    },
    handleError: function handleError(err, file, fileList) {
      console.log(err);
    },
    handleChange: function handleChange(file, fileList) {
      var _t = this;
      if (fileList.length >= 1) {
        _t.avatarIsMax = true;
      } else {
        _t.avatarIsMax = false;
      }
      return;
    },
    handleSuccess: function handleSuccess(res, file) {
      var _t = this;
      _t.fullscreenLoading = false;
      if (res.code === '401') {
        _t.$messagewarning('登录验证已失效，请重新登录');
        _t.$router.push('/login/');
        return;
      }
      if (res.error === 1) {
        _t.$messageerror(res.message);
        return;
      } else {
        _t.user.avatar_url = res.file;
        _t.avatarList.push({ file: res.file, url: _t.baseUrl + res.file });
        _t.avatarIsMax = true;
        return;
      }
    },
    beforeUpload: function beforeUpload(file) {
      var _t = this;
      var regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/;
      var isLtSize = file.size / 1024 / 1024 < 2;

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件');
        _t.avatarIsMax = false;
        return false;
      }
      if (!isLtSize) {
        this.$messagewarning('上传图片大小不能超过2M!');
        _t.avatarIsMax = false;
        return false;
      }
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ __webpack_exports__["default"] = ({
  inject: ['reload'],
  data: function data() {
    return {
      url: this.API,
      expandedEntryKey: '',
      entries: []
    };
  },

  components: {},
  created: function created() {
    var _t = this;
    this._getData();
  },

  computed: {},
  mounted: function mounted() {},

  methods: {
    _getData: function _getData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/entrylist/').then(function (resp) {
        if (resp.data.code == '0') {
          _t.entries = resp.data.data;
        } else {
          _t.$messagewarning(resp.data.msg);
          console.log(resp.data);
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    },
    convertGrade: function convertGrade(val) {
      if (val == '1') return '一年级';
      if (val == '2') return '二年级';
      if (val == '3') return '三年级';
      if (val == '4') return '赛道二';
    },
    entryKey: function entryKey(entry, index) {
      return 'entry-' + entry.year + '-' + entry.eid + '-' + index;
    },
    collapseEntry: function collapseEntry(entry, index) {
      var targetKey = entry ? this.entryKey(entry, index) : '';
      this.expandedEntryKey = '';
      if (targetKey) {
        this.$nextTick(function () {
          var target = document.getElementById(targetKey);
          if (target) target.scrollIntoView();
        });
      }
    },
    checkmore: function checkmore(entry, index) {
      this.expandedEntryKey = this.entryKey(entry, index);
    }
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      url: this.API,
      categories: [{
        type: 'year',
        value: '2021',
        enums: [{
          id: 1,
          name: '2021'
        }]
      }, {
        type: 'group',
        value: '0',
        enums: [{ 'id': '0', 'name': '全部作品' }, { 'id': '1', 'name': '大一作品' }, { 'id': '2', 'name': '大二作品' }, { 'id': '3', 'name': '大三作品' }]
      }],
      groups: [{ 'id': '0', 'name': '全部作品' }, { 'id': '1', 'name': '大一作品' }, { 'id': '2', 'name': '大二作品' }, { 'id': '3', 'name': '大三作品' }],
      topShow: false,
      page: '1',
      rows: '20',
      wid: '',
      works: [],
      imgsList: [],
      curWork: {},
      total: '104'
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.wid = this.$route.params.id ? this.$route.params.id : '';
      this._getData();
    }
  },
  computed: {
    pid: function pid() {
      return this.categories[1].value;
    }
  },
  created: function created() {
    console.log('created', this.wid);
  },
  mounted: function mounted() {
    this.wid = this.$route.params.id ? this.$route.params.id : '';
    this._getData();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  filters: {},
  methods: {
    handleSelectChange: function handleSelectChange(type) {
      this.page = 1;
      this._getData();
    },
    handleScroll: function handleScroll() {
      if (this.wid != "" && this.wid != undefined) {
        var sTop = document.documentElement.scrollTop;
        var top = this.$refs.leftbox.offsetTop;
        var height = this.$refs.rightbox.offsetHeight;
        if (sTop > top && sTop < height) {
          this.topShow = true;
        } else {
          this.topShow = false;
        }
      }
    },

    _getData: function _getData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      if (_t.wid == '' || _t.wid == undefined) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/toplist/', { gid: _t.pid, page: _t.page, rows: _t.rows, total: _t.total }).then(function (resp) {
          _t.works = resp.data.data;
          ld.close();
        }).catch(function (error) {
          console.log(error);
          ld.close();
        });
        this.total = _t.total;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/topdetail/', { id: _t.wid }).then(function (resp) {
          ld.close();
          if (resp.data.data == undefined) {
            _t.$messagewarning('当前作品不存在');
          } else {
            _t.curWork = resp.data.data;
            var result = [];
            for (var i = 0; i < _t.curWork.imgs_url.split(':')[0].split(';').length; i++) {
              var tmpImg = _t.curWork.imgs_url.split(':')[0].split(';')[i];
              if (tmpImg != '' && tmpImg != undefined) result.push(_t.url + '/assets/upload/' + tmpImg);
            }
            if (_t.curWork.imgs_url.split(':').length > 1) {
              for (var i = 0; i < _t.curWork.imgs_url.split(':')[1].split(';').length; i++) {
                var tmpImg = _t.curWork.imgs_url.split(':')[1].split(';')[i];
                if (tmpImg != '' && tmpImg != undefined) result.push(_t.url + '/assets/upload/' + tmpImg);
              }
            }
            _t.imgsList = result;
          }
        }).catch(function (error) {
          ld.close();
          console.log(error);
        });
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.rows = val;
      this.page = 1;
      this._getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this._getData();
    },
    goDetail: function goDetail(val) {
      console.log('work wid:', val);
      var routeUrl = this.$router.resolve({
        path: '/exhibition/' + val
      });
      window.open(routeUrl.href, '_blank');
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            username: '',
            email: '',
            code: '',
            verification_code: ''
        };
    },

    components: {},
    methods: {
        checkUsername: function checkUsername() {
            var _t = this;
            if (_t.username === '') {
                return _t.$messagewarning("用户名不能为空");
            }
        },
        checkEmail: function checkEmail() {
            var _t = this;
            var mailReg = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
            if (_t.email === '') {
                return _t.$messagewarning("邮箱不能为空");
            }
            if (!mailReg.test(_t.email)) {
                return _t.$messagewarning("请输入正确的邮箱格式");
            }
        },
        sendEmail: function sendEmail() {
            var _t = this;

            if (_t.email === '') {
                return _t.$messagewarning("邮箱不能为空");
            }
            _t.code = '';
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var len = 6;
            var maxPos = chars.length;
            for (var i = 0; i < len; i++) {
                var randomNum = Math.floor(Math.random() * maxPos);
                var char = chars.charAt(randomNum);
                _t.code += char;
            }
            var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '邮件发送中，请稍后' });
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/regist/sendMail/', { 'email': _t.email, 'code': _t.code }).then(function (resp) {
                if (resp.data.code === '409') {
                    _t.$messagewarning(resp.data.msg);
                    ld.close();
                    return;
                }

                if (resp.data.code === '0') {
                    _t.$messagesuccess(resp.data.msg);
                } else {
                    _t.$messageerror(resp.data.msg);
                }

                ld.close();
            }).catch(function (error) {
                console.log(error);
                ld.close();
            });
        },
        update: function update() {
            var _t = this;
            if (_t.username === '') {
                return _t.$messagewarning("用户名不能为空");
            }
            if (_t.email === '') {
                return _t.$messagewarning("邮箱不能为空");
            }
            if (_t.verification_code === '') {
                return _t.$messagewarning("请输入验证码");
            }
            if (_t.code === _t.verification_code) {
                _t.$router.push({ name: 'ChangePwd', params: { username: _t.username, email: _t.email } });
            } else {
                _t.$messagewarning("请输入正确的验证码");
            }
        }
    }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  inject: ['reload'],
  data: function data() {
    return {
      centerDialogVisible: false
    };
  },
  created: function created() {
    if (this.isMobile()) {
      this.centerDialogVisible = true;
    }
  },

  computed: {},
  mounted: function mounted() {},

  methods: {
    isMobile: function isMobile() {
      var userAgentInfo = navigator.userAgent;
      var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      var mobile_flag = false;

      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      var screen_width = window.screen.width;
      var screen_height = window.screen.height;

      if (screen_width < 500 && screen_height < 800) {
        mobile_flag = true;
      }
      return mobile_flag;
    }
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_js_dist_video_js_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_js_dist_video_js_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_video_js_dist_video_js_css__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_0_vue_video_player__["videoPlayer"]
  },
  data: function data() {
    return {
      playerOptions1: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
          type: 'video/mp4',
          src: 'http://archirookies.com/assets/upload/videos/chengli.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/chengli.jpg'
      },
      playerOptions2: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
          type: 'video/mp4',
          src: 'http://archirookies.com/assets/upload/videos/chenjun.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/chenjun.jpg'
      },
      playerOptions3: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        notSupportedMessage: '此视频无法播放，请稍后再试',
        sources: [{
          type: 'video/mp4',
          src: 'http://archirookies.com/assets/upload/videos/zhangsong.mp4'
        }],
        poster: 'http://archirookies.com/assets/upload/videos/zhangsong.jpg'
      } };
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    }
  },
  mounted: function mounted() {},

  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {}
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_md5__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_md5__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      pwd: ''
    };
  },
  mounted: function mounted() {
    var _t = this;
    document.onkeydown = function (ev) {
      var event = ev || event;
      if (event.keyCode == 13) {
        _t.login();
      }
    };
  },

  computed: {
    hmac: function hmac() {
      return __WEBPACK_IMPORTED_MODULE_2_md5___default()(this.username + this.pwd);
    }
  },
  created: function created() {
    var _t = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key === 13) {
        _t.login();
      }
    };
  },

  methods: {
    login: function login() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据提交中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/login/', { username: _t.username, pwd: _t.pwd, hmac: _t.hmac, role: 'user' }).then(function (resp) {
        if (resp.data.code === '0') {
          _t.$emit('token', resp.data.user.token);
          _t.$emit('role', 'user');
          _t.$router.push('/');
        } else {
          _t.$messageerror(resp.data.msg);
        }

        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      url: this.API,
      token: '',
      gidPair: {},
      channels: [{
        value: "1", label: "中国建筑新人赛"
      }],
      groups: [{
        key: '1', name: '大一'
      }, {
        key: '2', name: '大二'
      }, {
        key: '3', name: '大三'
      }],
      audiences: [{
        value: '10', label: '其他'
      }, {
        value: '1', label: '展览'
      }, {
        value: '2', label: '活动中心（城市综合体）'
      }, {
        value: '3', label: '居住类'
      }, {
        value: '4', label: '景观建筑'
      }, {
        value: '5', label: '空间小品'
      }, {
        value: '6', label: '工作室'
      }, {
        value: '7', label: '教育建筑（学校/幼儿园）'
      }, {
        value: '8', label: '大空间场馆类'
      }, {
        value: '9', label: '观演建筑'
      }],
      envs: [{
        value: '10', label: '其他'
      }, {
        value: '1', label: '山地'
      }, {
        value: '2', label: '滨水'
      }, {
        value: '3', label: '临水'
      }, {
        value: '4', label: '历史街区'
      }, {
        value: '5', label: '改扩建'
      }, {
        value: '6', label: '复杂城市环境'
      }, {
        value: '7', label: '乡村环境'
      }, {
        value: '8', label: '大自然环境'
      }, {
        value: '9', label: '无明显特征'
      }],
      areas: [{
        value: '10', label: '其他'
      }, {
        value: '1', label: '小品类（百平米内）'
      }, {
        value: '2', label: '小型（几百平米）'
      }, {
        value: '3', label: '中型（几千平米）'
      }, {
        value: '4', label: '小型建筑群落'
      }],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogCoverUrl: '',
      dialogCoverVisible: false,
      dialogSpecUrl: '',
      dialogSpecVisible: false,
      imageIsMax: false,
      image2IsMax: false,
      videoIsMax: false,
      coverIsMax: false,
      specIsMax: false,
      work: {
        name: '',
        gid: '',
        channel: '1',
        teacher: '',
        teacherComment: '',
        creativeNote: '',
        cover: '',
        spec: '',
        imgsArr: [],
        imgs2Arr: [],
        video: '',
        audience: '',
        audienceOther: '',
        env: '',
        envOther: '',
        area: '',
        areaOther: '' }
    };
  },

  computed: {
    headers: function headers() {
      var _t = this;
      return {
        Token: _t.token
      };
    }
  },
  watch: {
    'work.channel': {
      handler: function handler(newVal, oldVal) {
        this.work.imgsArr = [];
        this.work.imgs2Arr = [];
        console.log(this.work);
      }
    }
  },
  mounted: function mounted() {
    var _t = this;
    _t.token = _t.$ls.get('token');
    if (_t.token == '') {
      _t.$messagewarning('请先登录，再上传');
      _t.$router.push('/login/');
    }
  },

  methods: {
    handleRemove: function handleRemove(type, file, fileList) {
      var _t = this;
      var fileName = file.response.file;
      var index = -1;
      if (_t.work.channel != '2' && type === 'image') {
        if (fileList.length >= 4) {
          _t.imageIsMax = true;
        } else {
          _t.imageIsMax = false;
        }
        index = _t.work.imgsArr.indexOf(fileName);
        if (index > -1) {
          _t.work.imgsArr.splice(index, 1);
        }
        return;
      }

      if (_t.work.channel === '2' && type === 'image') {
        if (fileList.length >= 5) {
          _t.imageIsMax = true;
        } else {
          _t.imageIsMax = false;
        }
        index = _t.work.imgsArr.indexOf(fileName);
        if (index > -1) {
          _t.work.imgsArr.splice(index, 1);
        }
        return;
      }

      if (_t.work.channel === '2' && type === 'image2') {
        if (fileArr.length >= 2) {
          _t.image2IsMax = true;
        } else {
          _t.image2IsMax = false;
        }
        index = _t.work.imgs2Arr.indexOf(fileName);
        if (index > -1) {
          _t.work.imgs2Arr.splice(index, 1);
        }
        return;
      }

      if (type === 'video') {
        _t.work.video = '';
        if (fileList.length >= 1) {
          _t.videoIsMax = true;
        } else {
          _t.videoIsMax = false;
        }

        return;
      }
      if (type === 'cover') {
        _t.work.cover = '';
        if (fileList.length >= 1) {
          _t.coverIsMax = true;
        } else {
          _t.coverIsMax = false;
        }
        return;
      }
      if (type === 'spec') {
        _t.work.spec = '';
        if (fileList.length >= 1) {
          _t.specIsMax = true;
        } else {
          _t.specIsMax = false;
        }
        return;
      }
    },
    handleImageExceed: function handleImageExceed(type, file, fileList) {
      var _t = this;
      if (_t.work.channel === '2') {
        if (type === 'image') {
          this.$messagewarning('最多上传5张照片');
        } else if (type === 'image2') {
          this.$messagewarning('最多上传2张照片');
        }
      } else {
        this.$messagewarning('最多上传4张照片');
      }
    },
    handleVideoExceed: function handleVideoExceed(file, fileList) {
      this.$messagewarning('最多上传1个视频');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleCoverPreview: function handleCoverPreview(file) {
      this.dialogCoverUrl = file.url;
      this.dialogCoverVisible = true;
    },
    handleSpecPreview: function handleSpecPreview(file) {
      this.dialogSpecUrl = file.url;
      this.dialogSpecVisible = true;
    },
    handleError: function handleError(type, err, file, fileList) {
      console.log(err);
    },
    handleChange: function handleChange(type, file, fileList) {
      var _t = this;
      if (_t.work.channel != '2') {
        if (type === 'image') {
          if (fileList.length >= 4) {
            _t.imageIsMax = true;
          } else {
            _t.imageIsMax = false;
          }
          return;
        }
      } else {
        if (type === 'image') {
          if (fileList.length >= 5) {
            _t.imageIsMax = true;
          } else {
            _t.imageIsMax = false;
          }
          return;
        }

        if (type === 'image2') {
          if (fileList.length >= 2) {
            _t.image2IsMax = true;
          } else {
            _t.image2IsMax = false;
          }
          return;
        }
      }

      if (type === 'video') {
        if (fileList.length >= 1) {
          _t.videoIsMax = true;
        } else {
          _t.videoIsMax = false;
        }
        return;
      }
      if (type === 'cover') {
        if (fileList.length >= 1) {
          _t.coverIsMax = true;
        } else {
          _t.coverIsMax = false;
        }
        return;
      }
      if (type === 'spec') {
        if (fileList.length >= 1) {
          _t.specIsMax = true;
        } else {
          _t.specIsMax = false;
        }
        return;
      }
    },
    handleSuccess: function handleSuccess(type, res, file) {
      var _t = this;
      _t.fullscreenLoading = false;
      if (res.code === '401') {
        _t.$messagewarning('登录验证已失效，请重新登录');
        _t.$router.push('/login/');
        return;
      }
      if (res.error === 1) {
        _t.$messageerror(res.message);
        return;
      } else {
        if (type === 'image') {
          _t.work.imgsArr.push(res.file);
          return;
        }
        if (type === 'image2') {
          _t.work.imgs2Arr.push(res.file);
          return;
        }
        if (type === 'video') {
          _t.work.video = res.file;
          return;
        }
        if (type === 'cover') {
          _t.work.cover = res.file;
          return;
        }
        if (type === 'spec') {
          _t.work.spec = res.file;
          return;
        }
      }
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var _t = this;
      var regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件');
        _t.imageIsMax = false;
        return false;
      }
      if (!isLt2M) {
        this.$messagewarning('上传图片大小不能超过 2MB!');
        _t.imageIsMax = false;
        return false;
      }
      if (_t.work.channel === '2' && _t.work.imgsArr.length + _t.work.imgs2Arr.length >= 6) {
        this.$messagewarning('最多上传6张图纸！');
      }
    },
    beforeUpload: function beforeUpload(file) {
      var _t = this;
      var regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/;
      var isLtSize = file.size / 1024 < 400;

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件');
        _t.coverIsMax = false;
        return false;
      }
      if (!isLtSize) {
        this.$messagewarning('上传图片大小不能超过400KB!');
        _t.coverIsMax = false;
        return false;
      }
    },
    beforeVideoUpload: function beforeVideoUpload(file) {
      var _t = this;
      var isLt100M = file.size / 1024 / 1024 < 100;
      if (['video/mp4'].indexOf(file.type) === -1) {
        this.$messagewarning('请上传正确的视频格式');
        _t.videoIsMax = false;
        return false;
      }
      if (!isLt100M) {
        this.$messagewarning('上传视频大小不能超过100MB!');
        _t.videoIsMax = false;
        return false;
      }
    },

    validateInput: function validateInput() {
      var _t = this;
      if (_t.work.channel === undefined) {
        _t.$messagewarning('请选择参赛赛道');
        return;
      }
      if (_t.gidPair.gid === undefined && _t.work.channel != 2) {
        _t.$messagewarning('请选择参赛组别');
        return;
      }
      if (_t.work.name === '') {
        _t.$messagewarning('请输入作品名称');
        return;
      }

      if (_t.work.teacher === '') {
        _t.$messagewarning('请输入指导老师姓名');
        return;
      }
      if (_t.work.teacherComment.length < 10) {
        _t.$messagewarning('指导老师点评不能小于10字');
        return;
      }
      if (_t.work.creativeNote.length < 200) {
        _t.$messagewarning('作品设计说明不能小于200字');
        return;
      }
      if (_t.work.cover === '') {
        _t.$messagewarning('请上传作品封面');
        return;
      }
      if (_t.work.spec === '') {
        _t.$messagewarning('请上传任务书');
        return;
      }
      if (_t.work.imgsArr.length == 0) {
        _t.$messagewarning('请上传至少1张作品图片');
        return;
      }
      if (_t.work.audience == '') {
        _t.$messagewarning('请选择作品功能内容类别');
        return;
      }
      if (_t.work.env == '') {
        _t.$messagewarning('请选择作品地形环境类别');
        return;
      }
      if (_t.work.area == '') {
        _t.$messagewarning('请选择作品面积类别');
        return;
      }
      return true;
    },
    save: function save() {
      var _t = this;
      if (_t.validateInput() != true) return;

      var imgsUrl = "";

      for (var i = 0; i < _t.work.imgsArr.length; i++) {
        imgsUrl = imgsUrl + (i == 0 ? _t.work.imgsArr[i] : ";" + _t.work.imgsArr[i]);
      }

      if (_t.work.channel === '2') {
        for (var i = 0; i < _t.work.imgs2Arr.length; i++) {
          imgsUrl = imgsUrl + (i == 0 ? ":" + _t.work.imgs2Arr[i] : ";" + _t.work.imgs2Arr[i]);
        }
      }

      var ld = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据提交中，请稍后' });
      var reqData = {};
      reqData = {
        token: _t.token,
        name: _t.work.name,
        teacher: _t.work.teacher,
        channel: _t.work.channel,
        gid: _t.work.channel === '2' ? 4 : _t.gidPair.gid,
        teachercomment: _t.work.teacherComment,
        creativenote: _t.work.creativeNote,
        cover: _t.work.cover,
        spec: _t.work.spec,
        imgsUrl: imgsUrl,
        video: _t.work.video,
        audience: _t.work.audience == '其他' ? _t.work.audienceOther : _t.work.audience,
        env: _t.work.env == '其他' ? _t.work.envOther : _t.work.env,
        area: _t.work.area == '其他' ? _t.work.areaOther : _t.work.area
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/work/apply/', reqData).then(function (resp) {
        if (resp.data.code === '0') {
          _t.$messagesuccess(resp.data.msg);
          _t.$router.push('/work/');
        } else {
          _t.$messagewarning(resp.data.msg);
          if (resp.data.code === '401') {
            _t.$router.push('/login/');
          }
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        _t.$messageerror(error);
        ld.close();
      });
    }
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sections: [{
        title: '关于新人赛',
        items: [{
          question: 'Q:我怎样报名参加竞赛呢？',
          answer: 'A：在本网站(http://www.archirookies.com/)上注册，登录并按提示流程提交作品即可。'
        }, {
          question: 'Q：我是一个规划系的学生，我可以参加比赛吗？',
          answer: 'A：规划类、景观类专业也欢迎参加！不过要注意比赛条件：投稿作业是本教学年度（2025-2026学年）的“建筑设计作业”。'
        }, {
          question: 'Q：我是一名四年级的学生，我可以投稿三年级时期的作品吗？',
          answer: 'A：抱歉，不可以。新人赛仅接收本教学年度（2025-2026学年）的建筑设计作品，原则上只有本科一至三年级可以报名。'
        }, {
          question: 'Q：我在做课程设计的时候是一个人，但是在之后更改课程设计和成图的时候是多人参与的，这种情况可算作个人成果么？',
          answer: 'A：按该课程设计的任务书要求，规定是一个人完成的话，则算作个人成果。'
        }, {
          question: 'Q：我想拿来参加比赛的设计基于学校历史和学校建筑空间的研究，学校历史或现状可能会在图里显示，这怎么办呀？',
          answer: 'A：这种情况的话图纸中只能写“某学校”。如果基地在学校里，场地周边的用房，道路都需要自行处理一下。只要不出现具体名称，图上出现建筑物的形象也没关系。'
        }, {
          question: 'Q：图纸中可以出现场地的实景照片吗？',
          answer: 'A：可以的，不出现选手、老师、学校信息即可。出现校园内的建筑形象是可以的，但是需要对出现的名称做处理。'
        }, {
          question: 'Q：能不能拿桥梁设计的作业参赛呢？',
          answer: 'A：新人赛欢迎各种作业的投稿，评委团队自有判断。'
        }, {
          question: 'Q：我要参加比赛的话是重新做一个设计还是修改自己的课程作业呢？',
          answer: 'A：修改课程作业为宜，这也是新人赛的初衷。'
        }]
      }, {
        title: '关于图纸',
        items: [{
          question: 'Q：我想用纯手绘的图纸参加比赛可以吗？',
          answer: 'A：完全可以。只需要把图纸扫描之后上传即可，但文件内容要与我们的具体要求相符。'
        }, {
          question: 'Q：赛道一海选要求提交的四页图纸是指什么格式的呢，有大小的要求吗？',
          answer: 'A：图纸格式的要求是jpeg、png格式都可以，没有版面大小的要求，但是文件大小要小于2MB；并小于4000×4000（像素）。（推荐手绘图纸可以排4张A2版面的图纸，这与最终决赛的图纸格式相对应，便于修改）'
        }, {
          question: 'Q：封面与图纸大小不一样？',
          answer: 'A：是的，封面规定的尺寸是800×600（像素）的横版。'
        }, {
          question: 'Q：我没有一次提交所有的图，是不是就没法保存已经提交的了？',
          answer: 'A：已经提交的图纸会保存，但是下次提交会将上一次提交的图纸覆盖，所以务必每次上传都要上传完整的图纸。'
        }, {
          question: 'Q：字体字数有要求吗？',
          answer: 'A：没有要求。'
        }, {
          question: 'Q：图纸中的文字说明是否有必要用英文？',
          answer: 'A：没有必要的。'
        }, {
          question: 'Q：封面的具体要求和作用可以再明确一下吗？',
          answer: 'A：评审评阅界面首先看到的是封面，点击进入后会看到任务书与图纸，所以在设计封面时可以放上效果图或设计一个LOGO，可以考虑封面与图纸风格的统一，为评审留下一个较好的印象哦~但要注意的是封面不能出现个人信息！封面的尺寸是800×600像素，请大家认真阅读公众号推送中所提到的要求。'
        }, {
          question: 'Q：我的四张图纸有明确的版面要求吗？',
          answer: 'A：没有。即无论是A1、A2、A3、A4，或者此比例之外皆可。但进入100强之后会有明确的图纸版面规范'
        }, {
          question: 'Q：我的四张图纸尺寸不同可以吗？',
          answer: 'A：图纸和图纸之间不要求大小一致，图纸和封面也不要求大小一致，但为了提高评委教师审阅体验，我们推荐四张大小一致的图纸。'
        }]
      }, {
        title: '关于任务书',
        items: [{
          question: 'Q：请问任务书有统一的格式吗？',
          answer: 'A：没有统一格式，依各学校具体情况。'
        }, {
          question: 'Q：请问任务书一页是交图片格式的还是word？',
          answer: 'A：jpeg或者png格式。'
        }, {
          question: 'Q：我的任务书有地形图的话要一起放上去吗？',
          answer: 'A：根据个人情况，可以放进去。'
        }, {
          question: 'Q：任务书可以直接使用学校统一的原版任务书吗？是否需要对内容进行修改？',
          answer: 'A：依个人情况而定，任务书需体现真实的课程要求相关信息，但不得包含学校、个人、指导老师信息。'
        }, {
          question: 'Q：任务书只能一页吗？作业任务书原本有好多页怎么办？',
          answer: 'A：是的，只能上传一页任务书。所以请大家将多页任务书排版整理成一页上传。任务书的尺寸要求是4000×4000像素。'
        }]
      }]
    };
  },

  components: {}
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_video_player__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_video_player__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_2_vue_video_player__["videoPlayer"]
  },
  data: function data() {
    return {
      showImage: false,
      curIndex: '',
      url: this.API,
      imgUrl: 'http://www.archirookies.com',
      groups: ['全部', '大一', '大二', '大三'],
      top: [],
      showBigImg: false,
      num: 0,
      dataList: {},
      positionTop: '',
      playerOptions: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4'
        }],
        poster: 'poster.jpg'
      }
    };
  },
  mounted: function mounted() {
    this.curIndex = 0;
    this._getData();
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    titleImage: function titleImage() {
      return this.imgUrl + '/assets/upload/' + this.dataList.cover;
    },
    task: function task() {
      return this.imgUrl + '/assets/upload/' + this.dataList.spec;
    },
    imgList: function imgList() {
      var imgsArr = this.dataList.imgs_url == undefined ? [] : this.dataList.imgs_url.split(';');
      var result = [];
      if (imgsArr.length == 0) {
        return result;
      }
      for (var i = 0; i < imgsArr.length; i++) {
        result.push(this.imgUrl + '/assets/upload/' + imgsArr[i]);
      }
      return result;
    }
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    imgDirection: function imgDirection() {
      this.positionTop = 'margin-top:' + (document.body.scrollHeight - 1500) + 'px';
    },
    backList: function backList() {
      var _this = this;

      this.showImage = false;
      console.log('cur ref', this.$refs[this.curIndex]);
      console.log('cur index', this.curIndex);
      this.$nextTick(function () {
        document.getElementById(_this.curIndex).scrollIntoView();
      });
    },
    showImageList: function showImageList(index) {
      this.curIndex = index;
      this.dataList = this.top[index];
      this.showImage = true;
      window.scrollTo(0, 0);
      if (this.dataList.video) this.playerOptions.sources[0].src = 'http://www.archirookies.com/assets/upload/' + this.dataList.video;
    },
    bigImg: function bigImg(index) {
      this.showBigImg = true;
      this.num = index;
      this.imgDirection();
    },
    prev: function prev() {
      if (this.num === 0) {
        this.num = 3;
      }
      this.num--;
      console.log(this.num);
    },
    next: function next() {
      if (this.num === 3) {
        this.num = 0;
      }
      this.num++;
    },

    _getData: function _getData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/recommend/').then(function (resp) {
        if (resp.data.code == '0') {
          _t.top = resp.data.data;
        } else {
          _t.$messagewarning(resp.data.msg);
          console.log(resp.data);
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    },
    page: function page(uri) {
      var _t = this;
      _t.$router.push('/' + uri + '/');
    }
  }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      url: this.API,
      schools: [],
      provs: [{ label: "北京市", value: "北京市" }, { label: "天津市", value: "天津市" }, { label: "河北省", value: "河北省" }, { label: "山西省", value: "山西省" }, { label: "内蒙古自治区", value: "内蒙古自治区" }, { label: "辽宁省", value: "辽宁省" }, { label: "吉林省", value: "吉林省" }, { label: "黑龙江省", value: "黑龙江省" }, { label: "上海市", value: "上海市" }, { label: "江苏省", value: "江苏省" }, { label: "浙江省", value: "浙江省" }, { label: "安徽省", value: "安徽省" }, { label: "福建省", value: "福建省" }, { label: "江西省", value: "江西省" }, { label: "山东省", value: "山东省" }, { label: "河南省", value: "河南省" }, { label: "湖北省", value: "湖北省" }, { label: "湖南省", value: "湖南省" }, { label: "广东省", value: "广东省" }, { label: "广西壮族自治区", value: "广西壮族自治区" }, { label: "海南省", value: "海南省" }, { label: "重庆市", value: "重庆市" }, { label: "四川省", value: "四川省" }, { label: "贵州省", value: "贵州省" }, { label: "云南省", value: "云南省" }, { label: "西藏自治区", value: "西藏自治区" }, { label: "陕西省", value: "陕西省" }, { label: "甘肃省", value: "甘肃省" }, { label: "青海省", value: "青海省" }, { label: "宁夏回族自治区", value: "宁夏回族自治区" }, { label: "新疆维吾尔自治区", value: "新疆维吾尔自治区" }, { label: "台湾省", value: "台湾省" }, { label: "香港特别行政区", value: "香港特别行政区" }, { label: "澳门特别行政区", value: "澳门特别行政区" }],
      regist: {
        username: '',
        pwd: '',
        pwd2: '',
        name: '',
        phone: '',
        addr: '',
        province: '',
        school: '',
        otherschool: '',
        email: ''
      }
    };
  },
  mounted: function mounted() {
    this.initData();
  },

  methods: {
    validatePass: function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.regist.pwd2 !== '') {
          this.$refs.registBasic.validateField('pwd2');
        }
        callback();
      }
    },
    validatePass2: function validatePass2(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请再次输入密码'));
      } else if (value !== this.regist.pwd) {
        return callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    checkPhone: function checkPhone(rule, value, callback) {
      var phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/;
      if (!value) {
        return callback(new Error('电话号码不能为空'));
      }
      setTimeout(function () {
        if (phoneReg.test(value) && 11 == value.length) {
          callback();
        } else {
          callback(new Error('请输入格式正确的11位电话号码'));
        }
      }, 100);
    },
    checkEmail: function checkEmail(rule, value, callback) {
      var mailReg = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      setTimeout(function () {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱格式'));
        }
      }, 100);
    },
    initData: function initData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/base/schoollist/').then(function (resp) {
        if (resp.data.code === '0') {
          for (var i = 0; i < resp.data.data.length; i++) {
            var item = resp.data.data[i];
            _t.schools.push({ value: item.name, label: item.name });
          }
          _t.schools.push({ value: '0', label: '其他' });
        } else {
          _t.$messagewarning(resp.data.msg);
        }

        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    },
    save: function save() {
      var _t = this;
      _t.$refs.registBasic.validate(function (valid) {
        if (!valid) {
          return;
        }
      });
      _t.$refs.registExtra.validate(function (valid) {
        if (valid) {
          if (_t.regist.school == '0' && _t.regist.otherschool == '') {
            _t.$messagewarning(请输入学校名称);
            return;
          }
          var ld = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据提交中，请稍后' });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/regist/', _t.regist).then(function (resp) {
            if (resp.data.code === '0') {
              _t.$messagesuccess(resp.data.msg);
              _t.$router.push('/login/');
            } else {
              _t.$messagewarning(resp.data.msg);
            }

            ld.close();
          }).catch(function (error) {
            console.log(error);
            ld.close();
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_video_player__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_video_player__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_2_vue_video_player__["videoPlayer"]
  },
  data: function data() {
    return {
      showImage: false,
      curIndex: '',
      url: this.API,
      imgUrl: 'http://www.archirookies.com',
      groups: ['全部', '大一', '大二', '大三'],
      top: [],
      showBigImg: false,
      num: 0,
      dataList: {},
      positionTop: '',
      playerOptions: {
        height: '360',
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: 'video/mp4'
        }],
        poster: 'poster.jpg'
      }
    };
  },
  mounted: function mounted() {
    this.curIndex = 0;
    this._getData();
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    titleImage: function titleImage() {
      return this.imgUrl + '/assets/upload/' + this.dataList.cover;
    },
    task: function task() {
      return this.imgUrl + '/assets/upload/' + this.dataList.spec;
    },
    imgList: function imgList() {
      var imgsArr = this.dataList.imgs_url == undefined ? [] : this.dataList.imgs_url.split(';');
      var result = [];
      if (imgsArr.length == 0) {
        return result;
      }
      for (var i = 0; i < imgsArr.length; i++) {
        result.push(this.imgUrl + '/assets/upload/' + imgsArr[i]);
      }
      return result;
    }
  },
  methods: {
    onPlayerPlay: function onPlayerPlay(player) {},
    onPlayerPause: function onPlayerPause(player) {},
    imgDirection: function imgDirection() {
      this.positionTop = 'margin-top:' + (document.body.scrollHeight - 1500) + 'px';
    },
    backList: function backList() {
      var _this = this;

      this.showImage = false;
      console.log('cur ref', this.$refs[this.curIndex]);
      console.log('cur index', this.curIndex);
      this.$nextTick(function () {
        document.getElementById(_this.curIndex).scrollIntoView();
      });
    },
    showImageList: function showImageList(index) {
      this.curIndex = index;
      this.dataList = this.top[index];
      this.showImage = true;
      window.scrollTo(0, 0);
      if (this.dataList.video) this.playerOptions.sources[0].src = 'http://www.archirookies.com/assets/upload/' + this.dataList.video;
    },
    bigImg: function bigImg(index) {
      this.showBigImg = true;
      this.num = index;
      this.imgDirection();
    },
    prev: function prev() {
      if (this.num === 0) {
        this.num = 3;
      }
      this.num--;
      console.log(this.num);
    },
    next: function next() {
      if (this.num === 3) {
        this.num = 0;
      }
      this.num++;
    },

    _getData: function _getData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/top100/').then(function (resp) {
        if (resp.data.code == '0') {
          _t.top = resp.data.data;
        } else {
          _t.$messagewarning(resp.data.msg);
          console.log(resp.data);
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    },
    page: function page(uri) {
      var _t = this;
      _t.$router.push('/' + uri + '/');
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      url: this.API,
      groups: ['大一', '大二', '大三'],
      top: []
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    _getData: function _getData() {
      var _t = this;
      var ld = __WEBPACK_IMPORTED_MODULE_1_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据加载中，请稍后' });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/toplist').then(function (resp) {
        if (resp.data.code == '0') {
          _t.top = resp.data.data;
        } else {
          _t.$messagewarning(resp.data.msg);
          console.log(resp.data);
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        ld.close();
      });
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: '',
      url: this.API,
      groupInfo: [],
      user: []
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this._getData();
  },

  filters: {},
  methods: {
    changePwd: function changePwd() {
      var _t = this;
      _t.$router.push({ name: 'UserChangePwd', params: { email: _t.user.email, username: _t.user.username } });
    },
    _getData: function _getData() {
      var _t = this;
      _t.token = _t.$ls.get('token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/user/all', { token: _t.token }).then(function (resp) {
        if (resp.data.code === '401') {
          _t.$router.push('/login/');
          return;
        }
        if (resp.data.code === '0') {
          _t.user = resp.data.user;
        } else {
          _t.$messagewarning(resp.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            email: '',
            newPwd: '',
            re_newPwd: ''
        };
    },

    mounted: function mounted() {
        if (this.$ls.get('token') == undefined) {
            this.$router.push('/login');
        }
        this.username = this.$route.params.username;
        this.email = this.$route.params.email;
    },
    methods: {
        next: function next() {
            var _t = this;
            if (_t.newPwd === "" || _t.re_newPwd === "") {
                return _t.$messagewarning("请输入新密码");
            }
            if (_t.newPwd === _t.re_newPwd) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/user/updatePwd', { token: this.$ls.get('token'), newPwd: _t.re_newPwd, username: _t.username, email: _t.email }).then(function (resp) {
                    if (resp.data.code === '0') {
                        _t.$messagesuccess(resp.data.msg);
                        _t.$ls.remove("token");
                        _t.$ls.remove("role");
                        _t.$router.push('/login');
                    } else {
                        _t.$messagewarning(resp.data.msg);
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } else {
                return _t.$messagewarning("两次密码输入不一致");
            }
        }
    }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      token: '',
      url: this.API,
      pid: '0',
      page: '1',
      rows: '20',
      works: [],
      count: 0
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this._getData();
  },

  filters: {},
  methods: {
    _getData: function _getData() {
      var _t = this;
      _t.token = _t.$ls.get('token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/mylist/', { token: _t.token, pid: _t.pid, page: _t.page, rows: _t.rows }).then(function (resp) {
        if (resp.data.code === '401') {
          _t.$router.push('/login/');
          return;
        }
        if (resp.data.code === '0') {
          _t.works = resp.data.data;
          _t.count = resp.data.data.length;
        } else {
          _t.$messagewarning(resp.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.rows = val;
      this.page = 1;
      this._getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this._getData();
    },
    goDetail: function goDetail(val) {
      this.$router.push('/workdetail/' + val);
    },
    convertGrade: function convertGrade(val) {
      var grades = ['一年级', '二年级', '三年级', '赛道二'];
      return grades[parseInt(val) - 1];
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  inject: ['reload'],
  data: function data() {
    return {
      token: '',
      url: this.API,
      topShow: false,
      wid: '',
      work: {}
    };
  },

  components: {},
  created: function created() {
    var _t = this;
    _t.wid = _t.$route.params.id;
    _t._getData();
  },

  computed: {},
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      var sTop = document.documentElement.scrollTop;
      var top = this.$refs.header.offsetTop;
      if (sTop > top) {
        this.topShow = true;
      } else {
        this.topShow = false;
      }
    },

    _getData: function _getData() {
      var _t = this;
      _t.token = _t.$ls.get('token');
      console.log('post request', _t.API);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/detail/', { token: _t.token, wid: _t.wid }).then(function (resp) {
        if (resp.data.code == '0') {
          _t.work = resp.data.data;
        } else {
          _t.$messagewarning(resp.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteWork: function deleteWork() {
      var _t = this;
      _t.token = _t.$ls.get('token');
      _t.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_t.API + '/api/work/mydelete/', { token: _t.token, id: _t.wid }).then(function (resp) {
          if (resp.data.code == '0') {
            _t.$messagesuccess('作品删除成功！');
            _t.$router.push(/work/);
          } else {
            _t.$messagewarning(resp.data.msg);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {
        _t.$messagewarning('已取消删除');
      });
    },
    updateWork: function updateWork() {
      var _t = this;
      _t.$router.push('/workdetailupdate/' + _t.wid);
    },
    convertGrade: function convertGrade(val) {
      var grades = ['一年级', '二年级', '三年级', '赛道二'];
      return grades[parseInt(val) - 1];
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      url: this.API,
      token: '',
      wid: '',
      baseUrl: this.API + 'assets/upload/',
      audiences: [{
        value: '1', label: '展览'
      }, {
        value: '2', label: '活动中心（城市综合体）'
      }, {
        value: '3', label: '居住类'
      }, {
        value: '4', label: '景观建筑'
      }, {
        value: '5', label: '空间小品'
      }, {
        value: '6', label: '工作室'
      }, {
        value: '7', label: '教育建筑（学校/幼儿园）'
      }, {
        value: '8', label: '大空间场馆类'
      }, {
        value: '9', label: '观演建筑'
      }, {
        value: '10', label: '其他'
      }],
      envs: [{
        value: '1', label: '山地'
      }, {
        value: '2', label: '滨水'
      }, {
        value: '3', label: '临水'
      }, {
        value: '4', label: '历史街区'
      }, {
        value: '5', label: '改扩建'
      }, {
        value: '6', label: '复杂城市环境'
      }, {
        value: '7', label: '乡村环境'
      }, {
        value: '8', label: '大自然环境'
      }, {
        value: '9', label: '无明显特征'
      }, {
        value: '10', label: '其他'
      }],
      areas: [{
        value: '1', label: '小品类（百平米内）'
      }, {
        value: '2', label: '小型（几百平米）'
      }, {
        value: '3', label: '中型（几千平米）'
      }, {
        value: '4', label: '小型建筑群落'
      }, {
        value: '10', label: '其他'
      }],
      dialogImageUrl: '',
      dialogVisible: false,
      dialogImage2Visible: false,
      dialogCoverUrl: '',
      dialogCoverVisible: false,
      dialogSpecUrl: '',
      dialogSpecVisible: false,
      imageIsMax: false,
      image2IsMax: false,

      videoIsMax: false,
      coverIsMax: false,

      specIsMax: false,
      showFileUpload: true,
      work: {
        name: '',
        gid: '',
        coflag: '',
        coworker: '',
        teacher: '',
        teacher_comment: '',
        note: '',
        cover: '',
        spec: '',
        video: '',
        audience: '',
        env: '',
        area: '' },
      coverList: [],

      specList: [],
      imgsList: [],
      imgs2List: [],
      videosList: []
    };
  },

  computed: {
    headers: function headers() {
      var _t = this;
      return {
        Token: _t.token
      };
    }
  },
  mounted: function mounted() {
    var _t = this;
    _t.token = _t.$ls.get('token');
    _t.wid = _t.$route.params.id;
    _t._getData();
  },

  methods: {
    _getData: function _getData() {
      var _t = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/work/detail/', { token: _t.token, wid: _t.wid }).then(function (resp) {
        if (resp.data.code == '0') {
          _t.work = resp.data.data;
          var imgs = _t.work.imgs_url.split(':');
          var imgsUrlArr = imgs[0] ? imgs[0].split(";") : [];
          for (var i = 0; i < imgsUrlArr.length; i++) {
            _t.imgsList.push({ name: 'img' + i, url: _t.baseUrl + imgsUrlArr[i], file: imgsUrlArr[i] });
          }
          var imgs2UrlArr = imgs[1] ? imgs[1].split(";") : [];
          for (var i = 0; i < imgs2UrlArr.length; i++) {
            _t.imgs2List.push({ name: 'img' + i, url: _t.baseUrl + imgs2UrlArr[i], file: imgs2UrlArr[i] });
          }
          if (imgsUrlArr.length >= 5) {
            _t.imageIsMax = true;
          }
          if (imgs2UrlArr.length >= 2) {
            _t.image2IsMax = true;
          }

          var videosUrlArr = _t.work.videos_url.trim(';').split(';');
          if (videosUrlArr.length >= 1 && videosUrlArr[0] != '') {
            _t.videoIsMax = true;
            _t.work.video = videosUrlArr[0];
            _t.videosList.push({ name: 'video', url: _t.baseUrl + videosUrlArr[0], file: videosUrlArr[0] });
          }
          if (_t.work.cover != "" && _t.work.cover != undefined) {
            _t.coverIsMax = true;
            _t.coverList.push({ name: 'cover', url: _t.baseUrl + _t.work.cover, file: _t.work.cover });
          }

          if (_t.work.spec != "" && _t.work.spec != undefined) {
            _t.specIsMax = true;
            _t.specList.push({ name: 'spec', url: _t.baseUrl + _t.work.spec, file: _t.work.spec });
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleRemove: function handleRemove(type, file, fileList) {
      console.log('type, file, fileList', type, file, fileList);
      var _t = this;
      console.log('imgsList', _t.imgsList);
      console.log('imgs2List', _t.imgs2List);
      var fileName = file.file;

      if (type === 'image') {
        var maxLen = _t.work.channel === '2' ? 5 : 5;
        if (fileList.length >= maxLen) {
          _t.imageIsMax = true;
        } else {
          _t.imageIsMax = false;
        }
        for (var i = 0; i < _t.imgsList.length; i++) {
          if (fileName == _t.imgsList[i].file) {
            _t.imgsList.splice(i, 1);
            break;
          }
        }
        return;
      }

      if (type === 'image2') {
        if (fileList.length >= 2) {
          _t.image2IsMax = true;
        } else {
          _t.image2IsMax = false;
        }
        for (var i = 0; i < _t.imgs2List.length; i++) {
          if (fileName == _t.imgs2List[i].file) {
            _t.imgs2List.splice(i, 1);
            break;
          }
        }
        return;
      }

      if (type === 'video') {
        _t.work.video = '';
        _t.videosList = [];
        _t.videoIsMax = false;
        return;
      }

      if (type === 'cover') {
        _t.work.cover = '';
        _t.coverList = [];
        _t.coverIsMax = false;
        return;
      }

      if (type === 'spec') {
        _t.work.spec = '';
        _t.specList = [];
        _t.specIsMax = false;
        return;
      }
    },
    handleImageExceed: function handleImageExceed(type, file, fileList) {
      var _t = this;
      if (type === 'image') {
        var maxLen = _t.work.channel === '2' ? 5 : 5;
        this.$messagewarning('最多上传' + maxLen + '张照片');
      } else if (type === 'image2') {
        this.$messagewarning('最多上传2张照片');
      }
    },
    handleVideoExceed: function handleVideoExceed(file, fileList) {
      this.$messagewarning('最多上传1个视频');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleCoverPreview: function handleCoverPreview(file) {
      this.dialogCoverUrl = file.url;
      this.dialogCoverVisible = true;
    },
    handleSpecPreview: function handleSpecPreview(file) {
      this.dialogSpecUrl = file.url;
      this.dialogSpecVisible = true;
    },
    handleError: function handleError(type, err, file, fileList) {
      console.log(err);
    },
    handleChange: function handleChange(type, file, fileList) {
      var _t = this;
      if (type === 'image') {
        var maxLen = _t.work.channel === '2' ? 5 : 5;
        if (fileList.length >= maxLen) {
          _t.imageIsMax = true;
        } else {
          _t.imageIsMax = false;
        }
        return;
      }

      if (type === 'image2') {
        if (fileList.length >= 2) {
          _t.image2IsMax = true;
        } else {
          _t.image2IsMax = false;
        }
        return;
      }

      if (type === 'video') {
        if (fileList.length >= 1) {
          _t.videoIsMax = true;
        } else {
          _t.videoIsMax = false;
        }
        return;
      }

      if (type === 'cover') {
        if (fileList.length >= 1) {
          _t.coverIsMax = true;
        } else {
          _t.coverIsMax = false;
        }
        return;
      }

      if (type === 'spec') {
        if (fileList.length >= 1) {
          _t.specIsMax = true;
        } else {
          _t.specIsMax = false;
        }
        return;
      }
    },
    handleSuccess: function handleSuccess(type, res, file) {
      var _t = this;
      _t.fullscreenLoading = false;
      if (res.code === '401') {
        _t.$messagewarning('登录验证已失效，请重新登录');
        _t.$router.push('/login/');
        return;
      }
      if (res.error === 1) {
        _t.$messageerror(res.message);
        return;
      } else {
        if (type === 'image') {
          _t.imgsList.push({ file: res.file, url: _t.baseUrl + res.file });
          return;
        }
        console.log('before upload', _t.imgsList);

        if (type === 'image2') {
          _t.imgs2List.push({ file: res.file, url: _t.baseUrl + res.file });
          return;
        }
        console.log('after upload', _t.imgs2List);

        if (type === 'video') {
          _t.work.video = res.file;
          _t.videosList.push({ file: res.file, url: _t.baseUrl + res.file });
          return;
        }

        if (type === 'cover') {
          _t.work.cover = res.file;
          _t.coverList.push({ file: res.file, url: _t.baseUrl + res.file });
          return;
        }

        if (type === 'spec') {
          _t.work.spec = res.file;
          _t.specList.push({ file: res.file, url: _t.baseUrl + res.file });
          return;
        }
      }
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var _t = this;
      var regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件');
        return false;
      }
      if (!isLt2M) {
        this.$messagewarning('上传图片大小不能超过 2MB!');
        return false;
      }
    },
    beforeUpload: function beforeUpload(file) {
      var _t = this;
      var regImage = /(\/jpg|\/jpeg|\/gif|\/png)$/;
      var isLtSize = file.size / 1024 < 1000;

      if (!regImage.test(file.type)) {
        this.$messagewarning('请上传正确的图片格式文件');
        _t.coverIsMax = false;
        return false;
      }
      if (!isLtSize) {
        this.$messagewarning('上传图片大小不能超过1M!');
        _t.coverIsMax = false;
        return false;
      }
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var _t = this;

      var fileExt = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (fileExt != 'doc' && fileExt != 'docx') {
        _t.$messagewarning('请上传.doc, .docx类型文件');
        return false;
      }

      var isLt5M = file.size / 1024 / 1024 < 2;

      if (!isLt5M) {
        _t.$messagewarning('上传文件大小不能超过2MB!');
        return false;
      }
    },
    beforeVideoUpload: function beforeVideoUpload(file) {
      var _t = this;
      var isLt100M = file.size / 1024 / 1024 < 100;
      if (['video/mp4'].indexOf(file.type) === -1) {
        this.$messagewarning('请上传正确的视频格式');
        _t.videoIsMax = false;
        return false;
      }
      if (!isLt100M) {
        this.$messagewarning('上传视频大小不能超过100MB!');
        _t.videoIsMax = false;
        return false;
      }
    },

    validateInput: function validateInput() {
      var _t = this;

      if (_t.work.note.length < 200) {
        _t.$messagewarning('作品设计说明不能小于200字');
        return;
      }
      if (_t.work.note.length > 1000) {
        _t.$messagewarning('作品设计说明不能多于1000字');
      }
      if (_t.work.cover === '') {
        _t.$messagewarning('请上传作品封面');
        return;
      }
      if (_t.imgsList.length < 2) {
        _t.$messagewarning('请上传至少2张作品图纸');
        return;
      }
      if (_t.work.channel === '2' && _t.imgs2List.length < 1) {
        _t.$messagewarning('请上传至少1张作品实物模型图纸');
        return;
      }

      return true;
    },
    save: function save() {
      var _t = this;
      if (_t.validateInput() != true) return;

      var imgsUrl = "";
      for (var i = 0; i < _t.imgsList.length; i++) {
        imgsUrl = imgsUrl + (i == 0 ? _t.imgsList[i].file : ";" + _t.imgsList[i].file);
      }

      for (var i = 0; i < _t.imgs2List.length; i++) {
        imgsUrl = imgsUrl + (i == 0 ? ":" + _t.imgs2List[i].file : ";" + _t.imgs2List[i].file);
      }

      var ld = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ 'fullscreen': true, 'text': '数据提交中，请稍后' });
      var reqData = {};
      reqData = {
        token: _t.token,
        id: _t.wid,
        name: _t.work.name,
        teacher: _t.work.teacher,
        teachercomment: _t.work.teacher_comment,
        spec: _t.work.spec,
        audience: _t.work.audience,
        env: _t.work.env,
        area: _t.work.area,
        file: _t.work.design_file,
        creativenote: _t.work.note,
        cover: _t.work.cover,
        imgsUrl: imgsUrl,
        video: _t.work.video
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(_t.API + '/api/work/updateworkdetail/', reqData).then(function (resp) {
        if (resp.data.code === '0') {
          _t.$messagesuccess(resp.data.msg);
          _t.$router.push('/work/');
        } else {
          _t.$messagewarning(resp.data.msg);
          if (resp.data.code === '401') {
            _t.$router.push('/login/');
          }
        }
        ld.close();
      }).catch(function (error) {
        console.log(error);
        _t.$messageerror(error);
        ld.close();
      });
    },
    convertGrade: function convertGrade(val) {
      var grades = ['一年级', '二年级', '三年级', '赛道二'];
      return grades[parseInt(val) - 1];
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/banner2025.fd459fc.png";

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/home-2025-logo-banner.86e9b60.png";

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/home-2025-school-logo.263a8d2.png";

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/home-group-photo-2025.36dfaae.jpg";

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(557)
__webpack_require__(556)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  "data-v-636e337b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  "data-v-0858a1e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)
__webpack_require__(544)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  "data-v-2bf800be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(558)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  "data-v-73efaaa4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(559)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  "data-v-7a942b9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)
__webpack_require__(546)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-2f22659f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(561)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  "data-v-9c277af2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)
__webpack_require__(541)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  "data-v-0ccfc572",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(562)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  "data-v-aaf76d3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(563)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  "data-v-bab8e14c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(564)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  "data-v-f22b5a70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(554)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  "data-v-601cc7f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(553)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  "data-v-4eb78e64",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(555)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  "data-v-6062e9c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(560)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  "data-v-8b2ccb00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  "data-v-3c77593a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  "data-v-3c82b314",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)
__webpack_require__(551)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  "data-v-400dee7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content-area-full"
  }, [_c('div', {
    staticClass: "dept_content clearfix"
  }, _vm._l((_vm.entries), function(entry, index) {
    return _c('div', {
      key: _vm.entryKey(entry, index),
      staticClass: "card-section"
    }, [_c('div', {
      staticClass: "card-section-wrapper",
      attrs: {
        "id": _vm.entryKey(entry, index)
      }
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": entry.cover == null ? _vm.url + '/assets/upload/' + entry.imgs_url.split(';')[0] : _vm.url + '/assets/upload/' + entry.cover,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品年份：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.year))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品序号：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.eid))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品名称：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.name))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作者姓名：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.username))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("所属学校：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.school))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("所在年级：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.convertGrade(entry.gid)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("指导老师：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.teacher))])]), _vm._v(" "), (_vm.expandedEntryKey == _vm.entryKey(entry, index)) ? _c('div', {
      staticClass: "primary-btn checkmore",
      on: {
        "click": function($event) {
          return _vm.collapseEntry()
        }
      }
    }, [_vm._v("收起作品")]) : _c('div', {
      staticClass: "primary-btn checkmore",
      on: {
        "click": function($event) {
          return _vm.checkmore(entry, index)
        }
      }
    }, [_vm._v(" 查看作品")])])]), _vm._v(" "), (_vm.expandedEntryKey == _vm.entryKey(entry, index)) ? _c('div', {
      staticClass: "imgs-box"
    }, [_vm._l((entry.imgs_url.split(';')), function(entryImg, index) {
      return _c('div', {
        key: index,
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": _vm.url + '/assets/upload/' + entryImg,
          "oncontextmenu": "return false;",
          "ondragstart": "return false;",
          "oncopy": "return false;",
          "onselect": "return false"
        }
      })])
    }), _vm._v(" "), (entry.videos_url) ? _c('div', _vm._l((entry.videos_url.split(';')), function(entryVideo, index) {
      return _c('div', {
        key: index,
        staticClass: "img-box",
        attrs: {
          "oncontextmenu": "return false;",
          "ondragstart": "return false;",
          "oncopy": "return false;",
          "onselect": "return false"
        }
      }, [_c('div', {
        staticClass: "zhezhao"
      }), _vm._v(" "), _c('video', {
        staticStyle: {
          "width": "960px"
        },
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": _vm.url + '/assets/upload/' + entryVideo,
          "type": "video/mp4"
        }
      }), _vm._v("\n                      当前浏览器不支持该视频格式\n                  ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "collapse-btn toclick",
      on: {
        "click": function($event) {
          return _vm.collapseEntry(entry, index)
        }
      }
    }, [_vm._v("收起作品")])], 2) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "works-box",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.channel),
      callback: function($$v) {
        _vm.$set(_vm.work, "channel", $$v)
      },
      expression: "work.channel"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.work.channel != '2') ? _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    attrs: {
      "value-key": "gid",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeGid
    },
    model: {
      value: (_vm.gidPair),
      callback: function($$v) {
        _vm.gidPair = $$v
      },
      expression: "gidPair"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": {
          'gid': item.key,
          'name': item.name
        }
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(4), _vm._v(" "), _c('el-input', {
    staticClass: "box-info el-input-mid",
    attrs: {
      "placeholder": "请输入作品名称"
    },
    model: {
      value: (_vm.work.name),
      callback: function($$v) {
        _vm.$set(_vm.work, "name", $$v)
      },
      expression: "work.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(5), _vm._v(" "), _c('el-input', {
    staticClass: "box-info",
    attrs: {
      "placeholder": "指导老师（多个老师以；分割）"
    },
    model: {
      value: (_vm.work.teacher),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacher", $$v)
      },
      expression: "work.teacher"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "rows": "5",
      "type": "textarea",
      "maxlength": "300",
      "show-word-limit": "",
      "placeholder": "请输入指导老师点评（ 不超过300个字）"
    },
    model: {
      value: (_vm.work.teacherComment),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacherComment", $$v)
      },
      expression: "work.teacherComment"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "type": "textarea",
      "rows": "8",
      "maxlength": "1000",
      "show-word-limit": "",
      "placeholder": "作品设计说明（ 不超过1,000个字）"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.work.creativeNote),
      callback: function($$v) {
        _vm.$set(_vm.work, "creativeNote", $$v)
      },
      expression: "work.creativeNote"
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      coverDisabled: _vm.coverIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "on-success": _vm.handleSuccess.bind(this, 'cover'),
      "on-error": _vm.handleError.bind(this, 'cover'),
      "on-change": _vm.handleChange.bind(this, 'cover'),
      "on-remove": _vm.handleRemove.bind(this, 'cover'),
      "on-preview": _vm.handleCoverPreview,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品封面")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过400K"), _c('br'), _vm._v("尺寸要求为800x600px（横版）")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogCoverVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCoverVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogCoverUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      specDisabled: _vm.specIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "on-success": _vm.handleSuccess.bind(this, 'spec'),
      "on-error": _vm.handleError.bind(this, 'spec'),
      "on-change": _vm.handleChange.bind(this, 'spec'),
      "on-remove": _vm.handleRemove.bind(this, 'spec'),
      "on-preview": _vm.handleSpecPreview,
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品任务书")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("尺寸小于4000x4000")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogSpecVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSpecVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogSpecUrl,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.work.channel != '2') ? [_c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.imageIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 6,
      "file-list": _vm.work.imgsArr,
      "accept": "image/jpeg,image/png,image/jpg",
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image'),
      "on-error": _vm.handleError.bind(this, 'image'),
      "on-change": _vm.handleChange.bind(this, 'image'),
      "on-remove": _vm.handleRemove.bind(this, 'image'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("尺寸小于4000x4000px"), _c('br'), _vm._v("最多可上传4张")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])] : [_c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.imageIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 6,
      "file-list": _vm.work.imgsArr,
      "accept": "image/jpeg,image/png,image/jpg",
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image'),
      "on-error": _vm.handleError.bind(this, 'image'),
      "on-change": _vm.handleChange.bind(this, 'image'),
      "on-remove": _vm.handleRemove.bind(this, 'image'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传2~5张图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.image2IsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 6,
      "file-list": _vm.work.imgs2Arr,
      "accept": "image/jpeg,image/png,image/jpg",
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image2'),
      "on-error": _vm.handleError.bind(this, 'image2'),
      "on-change": _vm.handleChange.bind(this, 'image2'),
      "on-remove": _vm.handleRemove.bind(this, 'image2'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image2'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传1~2张实体模型图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogImage2Visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImage2Visible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImage2Url,
      "alt": ""
    }
  })])], _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info video-works-up",
    class: {
      videoDisabled: _vm.videoIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "video/mp4",
      "on-success": _vm.handleSuccess.bind(this, 'video'),
      "on-error": _vm.handleError.bind(this, 'video'),
      "on-change": _vm.handleChange.bind(this, 'video'),
      "on-remove": _vm.handleRemove.bind(this, 'video'),
      "on-exceed": _vm.handleVideoExceed,
      "before-upload": _vm.beforeVideoUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品视频")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("选填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("MP4格式，不超过100M"), _c('br'), _vm._v("时长不超过2分钟")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(8), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.audience),
      callback: function($$v) {
        _vm.$set(_vm.work, "audience", $$v)
      },
      expression: "work.audience"
    }
  }, _vm._l((_vm.audiences), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.audience == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "placeholder": "请输入作品功能内容分类"
    },
    model: {
      value: (_vm.work.audienceOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "audienceOther", $$v)
      },
      expression: "work.audienceOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(9), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.env),
      callback: function($$v) {
        _vm.$set(_vm.work, "env", $$v)
      },
      expression: "work.env"
    }
  }, _vm._l((_vm.envs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.env == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "placeholder": "请输入作品地形环境分类"
    },
    model: {
      value: (_vm.work.envOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "envOther", $$v)
      },
      expression: "work.envOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(10), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.area),
      callback: function($$v) {
        _vm.$set(_vm.work, "area", $$v)
      },
      expression: "work.area"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.area == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "placeholder": "请输入作品面积分类"
    },
    model: {
      value: (_vm.work.areaOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "areaOther", $$v)
      },
      expression: "work.areaOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注意：1、 图纸、任务书中不得出现学校、个人信息；2、 本次新人赛不接受合作作业；3、本次新人赛不接受已经在其他竞赛中获奖的作品; 4、接受本科一至三年级作业，且须为本教学年度（2025-2026）作品!\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline"
  }, [_vm._v("参赛赛道（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline"
  }, [_vm._v("参赛组别（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline"
  }, [_vm._v("作品名称（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline"
  }, [_vm._v("指导老师（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("指导老师点评（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品设计说明（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品功能内容分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品地形环境分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品针对面积分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
}]}

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "type": "text",
      "placeholder": "请填写姓名"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("联络电话")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写联络电话",
      "type": "text"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("地址")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写联络地址",
      "type": "text"
    },
    model: {
      value: (_vm.user.addr),
      callback: function($$v) {
        _vm.$set(_vm.user, "addr", $$v)
      },
      expression: "user.addr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "disabled": "",
      "placeholder": "请填写邮箱",
      "type": "text"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("专业")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写专业",
      "type": "text"
    },
    model: {
      value: (_vm.user.major),
      callback: function($$v) {
        _vm.$set(_vm.user, "major", $$v)
      },
      expression: "user.major"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("指导老师")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写指导老师",
      "type": "text"
    },
    model: {
      value: (_vm.user.teacher),
      callback: function($$v) {
        _vm.$set(_vm.user, "teacher", $$v)
      },
      expression: "user.teacher"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "shenspan",
    attrs: {
      "placeholder": "请填写你的编号",
      "type": "text"
    },
    model: {
      value: (_vm.user.userid),
      callback: function($$v) {
        _vm.$set(_vm.user, "userid", $$v)
      },
      expression: "user.userid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.school))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校所在省份")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.province))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("个人生活照")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-up shenspan",
    class: {
      avatarDisabled: _vm.avatarIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.avatarList,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "on-preview": _vm.handlePreview,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传个人生活照一张")]), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("不建议为证件照或者艺术照")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "saveInfo"
  }, [_c('span', {
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.prepage
    }
  }, [_vm._v("返 回")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("修改基本资料")])])
}]}

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.wid == '' || _vm.wid == undefined) ? _c('div', {
    staticClass: "exhibition"
  }, [_c('ul', {
    staticClass: "layout-content categoryevery clearfix"
  }, _vm._l((_vm.categories), function(category, index) {
    return _c('li', {
      key: index
    }, [_c('el-select', {
      staticClass: "cselect",
      attrs: {
        "popper-class": "popperclass",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectChange(category.type)
        }
      },
      model: {
        value: (category.value),
        callback: function($$v) {
          _vm.$set(category, "value", $$v)
        },
        expression: "category.value"
      }
    }, _vm._l((category.enums), function(item) {
      return _c('el-option', {
        key: item.id,
        staticClass: "celoption",
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('ul', {
    staticClass: "categorywork clearfix"
  }, _vm._l((_vm.works), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'noright': index % 4 == 3
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + item.cover,
        "alt": "未上传封面"
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(item.id)
        }
      }
    }), _vm._v(" "), (item.top16 != '1000') ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "16强作品",
        "placement": "top-start"
      }
    }, [_c('div', {
      staticClass: "status",
      style: ({
        background: 'url(' + _vm.url + '/assets/img/top16.png)'
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titlebox"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.name,
        "placement": "top-start"
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "categorycon"
    }, [_c('span', {
      staticClass: "categoryname"
    }, [_vm._v(_vm._s(_vm.groups[item.gid].name))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "categoryname"
    }, [_vm._v("编号：" + _vm._s(item.userid))]), _vm._v(" "), _c('span', {
      staticClass: "wrapline"
    }, [_vm._v("|")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v("作者：" + _vm._s(item.username))])])])], 1)
  }), 0), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-page",
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "current-page": parseInt(_vm.page),
      "page-sizes": [20, 30, 50],
      "page-size": parseInt(_vm.rows),
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": parseInt(_vm.total)
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _c('div', {
    staticClass: "exhibition-detail"
  }, [_c('div', {
    staticClass: "titlebox"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.curWork.name))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-con layout-content"
  }, [_c('div', {
    ref: "leftbox",
    staticClass: "leftbox"
  }, [_c('div', {
    staticClass: "leftbox-con",
    class: _vm.topShow == true ? 'top' : ''
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("分组：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.groups[_vm.curWork.gid].name))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作者姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.username))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("学校：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.school))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.major))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("指导老师：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.teacher))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("编号：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.userid))])])]), _vm._v(" "), _c('div', {
    ref: "rightbox",
    staticClass: "rightbox",
    attrs: {
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  }, [_c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品说明：")]), _vm._v(" "), _c('div', {
    staticClass: "box-info",
    staticStyle: {
      "min-height": "50px"
    }
  }, [(_vm.curWork.note.length > 10) ? _c('div', {
    staticClass: "box-info",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.curWork.note) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品图纸：")]), _vm._v(" "), _c('div', {
    staticClass: "box-info"
  }, _vm._l((_vm.curWork.imgs_url.split(':')[0].split(';')), function(imgUrl, index) {
    return _c('el-image', {
      key: index,
      attrs: {
        "max-width": "600px",
        "src": _vm.url + '/assets/upload/' + imgUrl,
        "alt": "图片加载失败",
        "preview-src-list": _vm.imgsList,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })
  }), 1), _vm._v(" "), (_vm.curWork.imgs_url.split(':').length > 1) ? _c('div', {
    staticClass: "box-info"
  }, [_vm._v("实体模型照片：")]) : _vm._e(), _vm._v(" "), (_vm.curWork.imgs_url.split(':').length > 1) ? _c('div', {
    staticClass: "box-info"
  }, _vm._l((_vm.curWork.imgs_url.split(':')[1].split(';')), function(imgUrl, index) {
    return _c('el-image', {
      key: index,
      attrs: {
        "max-width": "600px",
        "src": _vm.url + '/assets/upload/' + imgUrl,
        "alt": "图片加载失败",
        "preview-src-list": _vm.imgsList,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.curWork.video != '') ? _c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品视频：")]) : _vm._e(), _vm._v(" "), (_vm.curWork.video != '') ? _c('div', {
    staticClass: "box-info"
  }, [_c('video', {
    ref: "video1",
    attrs: {
      "width": "600px",
      "height": "375px",
      "controls": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.curWork.video,
      "type": "video/mp4"
    }
  }), _vm._v("\n                    当前浏览器不支持该视频格式\n                ")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tech-items"
  }, [_c('div', {
    staticClass: "item-tech"
  }, [_vm._m(0), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions1
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_vm._m(1), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions2
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_vm._m(2), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions3
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——程力真老师专访")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——陈俊老师专访")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-video-camera",
    staticStyle: {
      "color": "#25335e",
      "font-size": "30px",
      "position": "relative",
      "top": "4px"
    }
  }), _vm._v(" "), _c('i', [_vm._v("【世说”新“语】Newords.2025——张嵩老师专访")])])
}]}

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "head-nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "head-option"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token == ''),
      expression: "token == ''"
    }],
    staticClass: "nav-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goAnchor('last')
      }
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token != ''),
      expression: "token != ''"
    }],
    staticClass: "nav-myinfo clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goAnchor('last')
      }
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "out"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出")])])]), _vm._v(" "), _c('div', {
    staticClass: "category clearfix"
  }, [_c('ul', {
    staticClass: "category-wrap clearfix"
  }, _vm._l((_vm.menus), function(menuItem, index) {
    return _c('li', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.toMenu(menuItem.path, index)
        }
      }
    }, [_c('router-link', {
      key: index,
      staticClass: "tab-item",
      attrs: {
        "to": menuItem.path
      }
    }, [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-area middle-content"
  }, [(_vm.isRouterAlive) ? _c('router-view', {
    on: {
      "token": _vm.changeToken
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "huojian yincang"
  }, [_vm._v("UP")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-logo"
  }, [_c('div', {
    staticClass: "site-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(583),
      "alt": "东大建筑新人赛"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "#/post"
    }
  }, [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal_info"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "small_line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/regist"
    }
  }, [_vm._v("注册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "#/post"
    }
  }, [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutme"
  }, [_c('div', [_vm._v("我的")]), _vm._v(" "), _c('ul', {
    staticClass: "zh_myinfo"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "color": "#182345"
    },
    attrs: {
      "href": "#/work"
    }
  }, [_vm._v("我的作品")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "color": "#182345"
    },
    attrs: {
      "href": "#/user"
    }
  }, [_vm._v("资料与账号")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    attrs: {
      "id": "last"
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "link_div"
  }, [_vm._v("主办单位: 东南大学建筑学院")]), _vm._v(" "), _c('div', {
    staticClass: "link_div"
  }, [_vm._v("官方邮箱: arch_newer@foxmail.com")]), _vm._v(" "), _c('div', {
    staticClass: "link_div",
    staticStyle: {
      "margin-top": "40px",
      "font-size": "12px"
    }
  }, [_vm._v("南京清晓信息科技有限公司 © 2025 "), _c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏ICP备13063229号-4")])]), _vm._v(" "), _c('div', {
    staticClass: "ball_wrap"
  }, [_c('div', {
    staticClass: "ball ball_wx"
  }, [_c('div', {
    staticClass: "erweima erweima_status"
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "font-family": "sy",
      "font-size": "12px",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  })])])])
}]}

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work"
  }, [_vm._m(0), _vm._v(" "), (_vm.works.length == 0) ? _c('div', {
    staticClass: "notification"
  }, [_c('span', [_vm._v(" 未上传作品 ")])]) : _c('div', [_c('ul', {
    staticClass: "categorywork clearfix"
  }, _vm._l((_vm.works), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'noright': index % 4 == 3
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + item.cover,
        "alt": "未上传封面"
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(item.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "categorycon"
    }, [(item.coworker != '') ? _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("合作者：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(item.coworker))])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("指导老师：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(item.teacher))])]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "label"
    }, [_vm._v("年 级：")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v(_vm._s(_vm.convertGrade(item.gid)))])])])])
  }), 0), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-page",
    staticStyle: {
      "width": "40%",
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "20px",
      "margin-right": "100px"
    },
    attrs: {
      "current-page": parseInt(_vm.page),
      "page-sizes": [20, 30, 50],
      "page-size": parseInt(_vm.rows),
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": parseInt(_vm.count)
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("我的作品")])])
}]}

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    ref: "header",
    staticClass: "content-area header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.work.name) + "\n    \t")]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('span', [_c('i', [_vm._v("年级：")]), _vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topShow),
      expression: "topShow"
    }],
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top-left"
  }, [_c('div', [_vm._v(_vm._s(_vm.work.name))]), _vm._v(" "), _c('div', [_c('span', [_c('i', [_vm._v("年级：")]), _vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-right"
  }, [_c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.deleteWork
    }
  }, [_vm._v(" 删除当前作品")]), _vm._v(" "), _c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.updateWork
    }
  }, [_vm._v(" 修改当前作品")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-area"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品设计说明：")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.work.note))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品功能内容分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.audience))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品地形环境分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.env))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品针对面积分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.area))])]), _vm._v(" "), (_vm.work.spec != '') ? _c('div', {
    staticClass: "label"
  }, [_vm._v("作品任务书：")]) : _vm._e(), _vm._v(" "), (_vm.work.spec != '') ? _c('div', {
    staticClass: "work-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.work.spec
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.work.imgs_url.split(':').length > 0) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品图纸图片：")]), _vm._v(" "), _vm._l((_vm.work.imgs_url.split(':')[0].split(';')), function(imgSrc, index) {
    return _c('div', {
      key: index,
      staticClass: "work-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + imgSrc
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.work.imgs_url.split(':').length > 1) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品实体模型照片：")]), _vm._v(" "), _vm._l((_vm.work.imgs_url.split(':')[1].split(';')), function(imgSrc, index) {
    return _c('div', {
      key: index,
      staticClass: "work-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + imgSrc
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.work.videos_url != '') ? _c('div', {
    staticClass: "label"
  }, [_vm._v("作品视频：")]) : _vm._e(), _vm._v(" "), (_vm.work.videos_url != '') ? _c('div', {
    staticClass: "work-video"
  }, [_c('div', {
    staticClass: "zhezhao"
  }), _vm._v(" "), _c('video', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.work.videos_url,
      "type": "video/mp4"
    }
  }), _vm._v("\n                当前浏览器不支持该视频格式\n         \t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-section"
  }, [_c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.deleteWork
    }
  }, [_vm._v(" 删除当前作品")]), _vm._v(" "), _c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.updateWork
    }
  }, [_vm._v(" 修改当前作品")])])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "works-box",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("参赛组别：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])]), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("作品名称：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info el-input-mid",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品名称"
    },
    model: {
      value: (_vm.work.name),
      callback: function($$v) {
        _vm.$set(_vm.work, "name", $$v)
      },
      expression: "work.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("指导老师：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info",
    attrs: {
      "disabled": "",
      "placeholder": "指导老师（多个老师以；分割）"
    },
    model: {
      value: (_vm.work.teacher),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacher", $$v)
      },
      expression: "work.teacher"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("指导老师点评：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "disabled": "",
      "rows": "5",
      "type": "textarea",
      "maxlength": "300",
      "show-word-limit": "",
      "placeholder": "请输入指导老师点评（ 不超过300个字）"
    },
    model: {
      value: (_vm.work.teacher_comment),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacher_comment", $$v)
      },
      expression: "work.teacher_comment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品设计说明：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "type": "textarea",
      "rows": "8",
      "minlength": "200",
      "maxlength": "1000",
      "show-word-limit": "",
      "placeholder": "作品设计说明，表达设计思路或设计理念（ 不少于200字，不多于1,000个字）"
    },
    model: {
      value: (_vm.work.note),
      callback: function($$v) {
        _vm.$set(_vm.work, "note", $$v)
      },
      expression: "work.note"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品封面上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      coverDisabled: _vm.coverIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.coverList,
      "on-success": _vm.handleSuccess.bind(this, 'cover'),
      "on-error": _vm.handleError.bind(this, 'cover'),
      "on-change": _vm.handleChange.bind(this, 'cover'),
      "on-remove": _vm.handleRemove.bind(this, 'cover'),
      "on-preview": _vm.handleCoverPreview,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品封面")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过1M"), _c('br'), _vm._v("尺寸要求2000x2000px")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogCoverVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCoverVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogCoverUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品任务书上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      specDisabled: _vm.specIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "disabled": "",
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.specList,
      "on-success": _vm.handleSuccess.bind(this, 'spec'),
      "on-error": _vm.handleError.bind(this, 'spec'),
      "on-change": _vm.handleChange.bind(this, 'spec'),
      "on-remove": _vm.handleRemove.bind(this, 'spec'),
      "on-preview": _vm.handleSpecPreview,
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品任务书")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("尺寸小于4000x4000")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogSpecVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSpecVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogSpecUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品图纸上传：")]), _vm._v(" "), (_vm.work.channel === '2') ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("2~5张图纸：")]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.imageIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 5,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.imgsList,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image'),
      "on-error": _vm.handleError.bind(this, 'image'),
      "on-change": _vm.handleChange.bind(this, 'image'),
      "on-remove": _vm.handleRemove.bind(this, 'image'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), (_vm.work.channel === '2') ? _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("A2横版")])]) : _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("每张尺寸为A2横版"), _c('br'), _vm._v("可上传2-5张")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.work.channel === '2') ? [_c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("1~2张实体模型照片：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.image2IsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 2,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.imgs2List,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image2'),
      "on-error": _vm.handleError.bind(this, 'image2'),
      "on-change": _vm.handleChange.bind(this, 'image2'),
      "on-remove": _vm.handleRemove.bind(this, 'image2'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image2'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传实体模型图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("每张尺寸为A2横版"), _c('br'), _vm._v("可上传1-2张")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogImage2Visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImage2Visible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImage2Url,
      "alt": ""
    }
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品视频上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info video-works-up",
    class: {
      videoDisabled: _vm.videoIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "video/mp4",
      "file-list": _vm.videosList,
      "on-success": _vm.handleSuccess.bind(this, 'video'),
      "on-error": _vm.handleError.bind(this, 'video'),
      "on-change": _vm.handleChange.bind(this, 'video'),
      "on-remove": _vm.handleRemove.bind(this, 'video'),
      "on-exceed": _vm.handleVideoExceed,
      "before-upload": _vm.beforeVideoUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品视频")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("选填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("MP4格式，不超过100M"), _c('br'), _vm._v("时长不超过2分钟")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(1), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.audience),
      callback: function($$v) {
        _vm.$set(_vm.work, "audience", $$v)
      },
      expression: "work.audience"
    }
  }, _vm._l((_vm.audiences), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.audience == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品功能内容分类"
    },
    model: {
      value: (_vm.work.audienceOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "audienceOther", $$v)
      },
      expression: "work.audienceOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.env),
      callback: function($$v) {
        _vm.$set(_vm.work, "env", $$v)
      },
      expression: "work.env"
    }
  }, _vm._l((_vm.envs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.env == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品地形环境分类"
    },
    model: {
      value: (_vm.work.envOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "envOther", $$v)
      },
      expression: "work.envOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.area),
      callback: function($$v) {
        _vm.$set(_vm.work, "area", $$v)
      },
      expression: "work.area"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.area == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品面积分类"
    },
    model: {
      value: (_vm.work.areaOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "areaOther", $$v)
      },
      expression: "work.areaOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定修改")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("作品修改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品功能内容分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品地形环境分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品针对面积分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
}]}

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body",
    staticClass: "section"
  }, [_c('div', [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.top), function(row, idx) {
    return _c('dd', [_c('div', {
      ref: idx,
      refInFor: true,
      staticClass: "container publicity",
      attrs: {
        "id": idx
      }
    }, [_c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[0]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[1]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[2]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row[3]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-3"
    }, [_vm._v(_vm._s(row[4]))])])])
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('div', {
    staticClass: "container publicity"
  }, [_c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("序号")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("学校")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("年级")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("作品名")])])])
}]}

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body",
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showImage),
      expression: "!showImage"
    }]
  }, [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.top), function(row, idx) {
    return _c('dd', [_c('div', {
      ref: idx,
      refInFor: true,
      staticClass: "container publicity",
      attrs: {
        "id": idx
      }
    }, [_c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row.username))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1 one-row"
    }, [_vm._v(_vm._s(row.school))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(_vm.groups[row.gid]))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-3 one-row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showImageList(idx)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(row.name))])])]), _vm._v(" "), (row.teacher) ? _c('div', {
      staticClass: "item col-md-2 one-row"
    }, [_vm._v(_vm._s(row.teacher))]) : _c('div', {
      staticClass: "item col-md-2"
    }, [_vm._v("无")])])])
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }]
  }, [_c('a', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("作品名称:")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.dataList.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("封面图:")]), _vm._v(" "), _c('img', {
    staticClass: "titleImage",
    attrs: {
      "src": _vm.titleImage,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "awardMsg",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("作品说明：")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.dataList.note))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("任务书:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.task,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("设计图：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "imageList"
    }
  }, [_c('div', {
    staticClass: "imgList"
  }, _vm._l((_vm.imgList), function(value, index) {
    return _c('div', {
      staticClass: "imgBox"
    }, [(!('http://www.archirookies.com/assets/upload/null' == _vm.imgList[index])) ? _c('img', {
      attrs: {
        "src": value,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', [(_vm.showBigImg) ? _c('div', {
    ref: "imgMask",
    staticClass: "imgMask",
    style: (_vm.positionTop),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBigImg = !_vm.showBigImg
      }
    }
  }, [_c('img', {
    staticClass: "prev imgPosition",
    attrs: {
      "src": __webpack_require__(217)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "showImg imgPosition",
    on: {
      "onmousewheel": function($event) {
        $event.preventDefault();
        return _vm.rollImg($event)
      }
    }
  }, [_c('img', {
    staticClass: "bigImg",
    attrs: {
      "src": _vm.imgList[_vm.num]
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "next imgPosition",
    attrs: {
      "src": __webpack_require__(216)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.dataList.video) ? _c('h1', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("视频:")])]) : _vm._e(), _vm._v(" "), (_vm.dataList.video) ? _c('div', {
    staticClass: "info-img"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('div', {
    staticClass: "container publicity"
  }, [_c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("作者")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("学校")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("年级")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-3 one-row"
  }, [_vm._v("参赛作品名")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-2"
  }, [_vm._v("指导教师")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("\n      <<- 返回作品列表")])])
}]}

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("联络电话")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("地址")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.addr))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("指导老师")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.teacher))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("专业")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.major))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("编号")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.userid))])]), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.school))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校所在省份")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.province))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("个人生活照")]), _vm._v(" "), (_vm.user.avatar_url != '') ? _c('span', {
    staticClass: "shenspan"
  }, [_c('img', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.user.avatar_url
    }
  })]) : _c('span', {
    staticClass: "shenspan"
  }, [_vm._v("无")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "black",
      "padding-bottom": "10px",
      "font-size": "14px",
      "border-bottom": "1px solid #f2f6fa",
      "margin-bottom": "20px"
    }
  }, [_vm._v("账号安全")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "changePwd",
    staticStyle: {
      "position": "relative",
      "top": "-40px",
      "left": "800px"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("修改密码")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("资料与账号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subtitle_wrap"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changeInfo",
    staticStyle: {
      "position": "relative",
      "left": "800px",
      "top": "-60px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/changeInfo"
    }
  }, [_vm._v("修改基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "40",
      "line-height": "40px",
      "color": "black",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("登陆密码")]), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("密码建议包含字母，符号或数字中的两项且长度超过8位，以保证账号更加安全。")])])
}]}

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "teach-items"
  }, [_c('h2', [_vm._v("评委采访")]), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: " vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsLi
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsXia
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsZhu
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsHu
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgetPwd"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": _vm.checkUsername,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱（注册时填写）"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": _vm.checkEmail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verification_code),
      expression: "verification_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verification_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verification_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "发送验证码至邮箱"
    },
    on: {
      "click": _vm.sendEmail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.update
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("忘记密码")])])
}]}

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("奖项设置")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top3")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品及10000元奖金")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top16")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品及2000元奖金")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top100")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品")]), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "90%",
      "center": ""
    }
  }, [_c('span', [_vm._v("本网站不支持移动端浏览，为了更好的用户体验，请在电脑上登录网站进行大赛报名")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(581),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section firsts"
  }, [_c('p', {}, [_vm._v("\n        一年一度的东南·中国建筑新人赛盛大归来！2026年，我们将再聚南京，在这里与来自不同学校的优秀选手肩并肩、与高水平的指导教师团队面对面；2026年，我们与去年保持一致，突破传统、追求独立，东南·中国建筑新人赛继续专注于中国建筑学的低年级教育、展现中国建筑新生的优异风采，着力于为低年级学生提供更好的竞赛平台与更多的交流机会。\n\t")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("新人赛是什么")]), _vm._v(" "), _c('p', [_vm._v("\n            新人赛为建筑学学生作业展示与竞赛、各国建筑教育者提供了积极的交流平台。 \n\n        ")]), _vm._v(" "), _c('p', {}, [_vm._v("\n            东南大学建筑学院突出“自主、开放、交流”的特点，面向全国各高校的本科一年级至三年级建筑专业学生征稿，旨在为年轻鲜活的低年级设计者提供竞赛平台，并鼓励他们展现创造性与合理性并存的设计思维，体现中国建筑学科的新生力量。 \n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(584),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("新人赛新在哪儿")]), _vm._v(" "), _c('p', [_vm._v("\n            中国建筑新人赛的定位是搭建全新的、颠覆传统建筑竞赛形式的竞赛平台，本质上是一场开放自由的建筑秀场和交流会。 \n\t    ")]), _vm._v(" "), _c('p', [_vm._v("\n            新人赛通过微信平台、作品网络提交、志愿者线下联系等多种途径让赛事信息最快传达；赛事经过海选评出的100强选手将被邀请至东南大学建筑学院，与来自五湖四海的建筑学学子彼此学习，与诸多建筑界精英面对面讨论方案、交流思想。同时，新人赛通过开放评选、学生参与、自发交流的三方面特点来消除传统竞赛作品提交、评选、发布等环节脱离，选手间、选手与主办方脱节的弊端。 \n\t    ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {}, [_vm._v("\n            让我们期待一同享受这属于建筑学界的饕餮盛宴！\n\t    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("组织机构")]), _vm._v(" "), _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name linetitle"
  }, [_vm._v("主办方")])]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("东南大学建筑学院、东南大学建筑设计研究院有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name linetitle"
  }, [_vm._v("协办方")])]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("《建筑学报》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参赛资格")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("参赛者")]), _vm._v(" "), _c('div', [_vm._v("\n            我们欢迎中国（含港澳台）各高校"), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("建筑学院（建筑系）三年级及以下")]), _vm._v("在读本科生投稿"), _c('br'), _c('br')]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("提交作品")]), _vm._v(" "), _c('div', [_vm._v("\n            前述参赛者在"), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("本科阶段一年级至-三年级")]), _vm._v("学习期间的建筑设计作业"), _c('br'), _c('br')]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("竞赛主题")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n            不设置竞赛主题，以各校教学环节的 "), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("设计任务书")]), _vm._v("为依据\n        ")]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("注意事项：")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n1. 以上条件必须同时满足"), _c('br'), _vm._v("\n2. 每个参赛者只能提交一份参赛作品"), _c('br'), _vm._v("\n3. 规划类或风景园林类专业学生亦可参赛，但投稿作品必须是建筑设计作品"), _c('br'), _vm._v("\n4. 提交作品应基于设计课作业成果，可进行一定的修改和完善，需提交设计科任务书且必须为本教学年度（2025-2026学年）作品（例：三年级同学只能提交第三学年作品，不得提交第一或第二学年作品）"), _c('br'), _vm._v("\n5. 不接受已经在其他竞赛中获奖的作品"), _c('br'), _vm._v("\n6. 不接受任何形式的合作作品（合作作品仅一人署名也不接受）"), _c('br'), _vm._v("\n7. 作品需以实体模型为重要表现载体，不接受无实体模型作品，入围100强的作品需按要求修改并提交至少一张模型照片"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赛程")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("即日起-2026.8.5中午12：00")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("报名并提交电子图纸到本网站。请按照网页提示内容填写参赛者个人信息，并依步骤上传图纸\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle "
  }, [_vm._v("图纸内容")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("封面1张，任务书1页，图纸4页，视频1个（如需要）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("注意事项")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("封面尺寸统一为800*600，图纸、任务书大小不超过2MB，分辨率在4000*4000以内，支持jpeg格式和png格式，除了登录信息以外，图纸上不得出现任何与参赛学校或个人相关的信息，否则投稿作品作废。图纸中不得使用繁体字。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.8.5-2026.8.11")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("海选评选")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("由各高校负责本科建筑设计教学的教师组成评委团队进行线上匿名打分，5分制，每个作品得分为三名评委的分数的平均分。并以此得分决定进入100强的参赛作品。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("网站公示")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("海选评选获奖结果经确认后将在本网站公布，同时公开100强作品供阅览。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.8.23-2026.9.17")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("进入前100名的参赛者对图纸进行修改与第二轮提交。（提交通道将于8.23开启）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("第二轮提交内容")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("每位参赛者提交2-5张图纸（A2横版）及1-2张实体模型照片（A2横版）\n（具体要求将后续通知）")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.9.20上午")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("100进16强决赛")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("评选方式：评委线下投票\n届时100强选手将来到现场参与布展，9月20日上午评委将在现场为图纸打分\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.9.20下午")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("总决赛")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("评选方式：线下答辩\n9月20日下午16强选手现场答辩，现场产生前三获得者\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(582),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changePwd"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPwd),
      expression: "newPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.newPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.re_newPwd),
      expression: "re_newPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.re_newPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.re_newPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "确认修改"
    },
    on: {
      "click": _vm.next
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("修改密码")])])
}]}

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register-login"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    attrs: {
      "type": "password",
      "name": "pwd",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "btn-section"
  }, [_c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("用户登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "#/regist"
    }
  }, [_vm._v("没有账号？点此处注册")])])
}]}

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qa-main"
  }, [_c('div', {
    staticClass: "qa"
  }, _vm._l((_vm.sections), function(section) {
    return _c('div', {
      key: section.title,
      staticClass: "qa-section"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _vm._l((section.items), function(item) {
      return [_c('p', {
        key: item.question,
        staticClass: "ask"
      }, [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('p', {
        key: item.answer,
        staticClass: "answer"
      }, [_vm._v(_vm._s(item.answer))])]
    })], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body",
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showImage),
      expression: "!showImage"
    }]
  }, [_c('dl', [_vm._m(0), _vm._v(" "), _vm._l((_vm.top), function(row, idx) {
    return _c('dd', [_c('div', {
      ref: idx,
      refInFor: true,
      staticClass: "container publicity",
      attrs: {
        "id": idx
      }
    }, [_c('div', {
      staticClass: "item col-md-1"
    }, [_vm._v(_vm._s(row.username))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-1 one-row"
    }, [_vm._v(_vm._s(row.school))]), _vm._v(" "), _c('div', {
      staticClass: "item col-md-3 one-row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showImageList(idx)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(row.name))])])]), _vm._v(" "), (row.teacher) ? _c('div', {
      staticClass: "item col-md-2 one-row"
    }, [_vm._v(_vm._s(row.teacher))]) : _c('div', {
      staticClass: "item col-md-2"
    }, [_vm._v("无")])])])
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }]
  }, [_c('a', {
    on: {
      "click": _vm.backList
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("作品名称:")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.dataList.name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("封面图:")]), _vm._v(" "), _c('img', {
    staticClass: "titleImage",
    attrs: {
      "src": _vm.titleImage,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "awardMsg",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("作品说明：")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.dataList.note))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("任务书:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.task,
      "alt": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  })]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("设计图：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "imageList"
    }
  }, [_c('div', {
    staticClass: "imgList"
  }, _vm._l((_vm.imgList), function(value, index) {
    return _c('div', {
      staticClass: "imgBox"
    }, [(!('http://www.archirookies.com/assets/upload/null' == _vm.imgList[index])) ? _c('img', {
      attrs: {
        "src": value,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', [(_vm.showBigImg) ? _c('div', {
    ref: "imgMask",
    staticClass: "imgMask",
    style: (_vm.positionTop),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showBigImg = !_vm.showBigImg
      }
    }
  }, [_c('img', {
    staticClass: "prev imgPosition",
    attrs: {
      "src": __webpack_require__(217)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "showImg imgPosition",
    on: {
      "onmousewheel": function($event) {
        $event.preventDefault();
        return _vm.rollImg($event)
      }
    }
  }, [_c('img', {
    staticClass: "bigImg",
    attrs: {
      "src": _vm.imgList[_vm.num]
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "next imgPosition",
    attrs: {
      "src": __webpack_require__(216)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.dataList.video) ? _c('h1', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("视频:")])]) : _vm._e(), _vm._v(" "), (_vm.dataList.video) ? _c('div', {
    staticClass: "info-img"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('div', {
    staticClass: "container publicity"
  }, [_c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("作者")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-1"
  }, [_vm._v("学校")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-3 one-row"
  }, [_vm._v("参赛作品名")]), _vm._v(" "), _c('div', {
    staticClass: "th item col-md-2"
  }, [_vm._v("指导教师")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('u', [_vm._v("\n        <<- 返回作品列表")])])
}]}

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "registBasic",
    staticClass: "register-form",
    attrs: {
      "model": _vm.regist,
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("账号信息填写")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "rules": [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.regist.username),
      callback: function($$v) {
        _vm.$set(_vm.regist, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "regist.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd",
      "rules": [{
        required: true,
        validator: _vm.validatePass,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.regist.pwd),
      callback: function($$v) {
        _vm.$set(_vm.regist, "pwd", $$v)
      },
      expression: "regist.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd2",
      "rules": [{
        required: true,
        validator: _vm.validatePass2,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "确认密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.regist.pwd2),
      callback: function($$v) {
        _vm.$set(_vm.regist, "pwd2", $$v)
      },
      expression: "regist.pwd2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "registExtra",
    staticClass: "register-form",
    attrs: {
      "model": _vm.regist,
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("基本信息填写")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系人（请输入真实姓名）"
    },
    model: {
      value: (_vm.regist.name),
      callback: function($$v) {
        _vm.$set(_vm.regist, "name", $$v)
      },
      expression: "regist.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.checkPhone,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系电话（作为我们联系您的方式请务必真实）"
    },
    model: {
      value: (_vm.regist.phone),
      callback: function($$v) {
        _vm.$set(_vm.regist, "phone", $$v)
      },
      expression: "regist.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "rules": [{
        required: true,
        validator: _vm.checkEmail,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱（作为我们联系您的方式请务必真实）"
    },
    model: {
      value: (_vm.regist.email),
      callback: function($$v) {
        _vm.$set(_vm.regist, "email", $$v)
      },
      expression: "regist.email"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择学校"
    },
    model: {
      value: (_vm.regist.school),
      callback: function($$v) {
        _vm.$set(_vm.regist, "school", $$v)
      },
      expression: "regist.school"
    }
  }, _vm._l((_vm.schools), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.regist.school == '0') ? _c('el-form-item', {
    attrs: {
      "prop": "otherschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入学校名称"
    },
    model: {
      value: (_vm.regist.otherschool),
      callback: function($$v) {
        _vm.$set(_vm.regist, "otherschool", $$v)
      },
      expression: "regist.otherschool"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "province",
      "rules": [{
        required: true,
        message: '请选择省份',
        trigger: 'blur'
      }]
    }
  }, [_c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择学校所在省份"
    },
    model: {
      value: (_vm.regist.province),
      callback: function($$v) {
        _vm.$set(_vm.regist, "province", $$v)
      },
      expression: "regist.province"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "addr",
      "rules": [{
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "地址"
    },
    model: {
      value: (_vm.regist.addr),
      callback: function($$v) {
        _vm.$set(_vm.regist, "addr", $$v)
      },
      expression: "regist.addr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "register-confirm"
  }, [_c('span', {
    staticClass: "submit",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "go_login"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("已有账号？点此处登陆")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("创建新账号")])])
}]}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151);
module.exports = __webpack_require__(218);


/***/ })

},[636]);


// WEBPACK FOOTER //
// assets/js/app.e40205f046f6e34cbbc4.js